<template>
  <div  class="content"   v-loading.fullscreen.lock="fullscreenLoading">
    
    <!-- 添加问卷页面 -->
    <div 
      id="contentRef"
      v-show="pageShow" 
      :style="'height:' + contentMainHeight + 'px;'"
      style="height: 100%;overflow-y: auto;"  >
      <div class="title-box">
        <el-button type="default" size="small" @click="$router.go(-1)">返回</el-button>
        <span>{{ subTitle }}</span>
      </div>

      <!-- 审核被驳回提示 -->
      <div class="review-reject-box" v-if="rejectRecordInfo">
        <div class="review-reject-header">
          <i class="el-icon-warning" style="color: #f56c6c; margin-right: 8px;"></i>
          <span style="color: #f56c6c; font-weight: bold;">审核被驳回</span>
        </div>
        <div class="review-reject-content">
          <span class="review-item">审批人：{{ rejectRecordInfo.staffName }}</span>
          <span class="review-item">审批时间：{{ rejectRecordInfo.approvalTime }}</span>
          <span class="review-item">审批意见：{{ rejectRecordInfo.approvalSuggest }}</span>
        </div>
      </div>

      <!-- 基本信息配置 -->
      <div class="base" style="margin-bottom: 4px">
        <div class="title" style="padding-left: 10px" @click="isExpand1=!isExpand1">
          <div class="title-config">
            <!-- <span class="title-block"></span> -->
            <i v-if="isExpand1" class="el-icon-caret-bottom"></i>
            <i v-else class="el-icon-caret-right"></i>
            基本信息配置
          </div>
          <!-- <div class="add-btn">
            <img width="20" src="../../assets/images/questionnaire_add.png" alt="" />
            <span>从模板中选择</span>
          </div> -->
        </div>
        <div v-show="isExpand1">
          <div class="base-content mt10 pb0">
            <div class="base-info">
              <div class="base-title"><span style="color: red">*</span>是否平台模板：</div>
              <div>
                <el-radio-group
                v-model="pageForm.isPlatformTemplate"
                size="mini"
                :disabled="isDetail"
                  >
                  <el-radio :label="'Y'">是</el-radio>
                  <el-radio :label="'N'">否</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="base-info" style="margin-left: 160px">
              <div class="base-title">
                问卷标签:
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="用于给传世数据采集任务打标签"
                  placement="top-start"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
              <el-cascader
                :value="pageForm.surveyLabelList"
                style="width: 300px; margin-left: -5px;"
                :disabled="isDetail"
                :options="surveyLabelOptions"
                collapse-tags
                filterable
                :show-all-levels="false"
                :props="{
                  value: 'value',
                  label: 'text',
                  children: 'childDictList',
                  multiple: true,
                  checkStrictly: true,
                  emitPath: false,
                }"
                @change="updateLabels"
                clearable
                popper-class="cascader-popper"
              >
              </el-cascader>
            </div>
            
          </div>
          <div class="base-content pb0" v-if="pageForm.isPlatformTemplate=='N'">
            <div class="base-info">
              <div class="base-title"><span style="color: red">*</span>应用公司：</div>
              <el-select
                style="width: 300px"
                :disabled="isEdit || isDetail"
                v-model="pageForm.tenantGuid"
                @change="handleSelectFactory"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in sendTenantList"
                  :key="index"
                  :label="item.tenantName"
                  :value="item.guid"
                ></el-option>
              </el-select>
            </div>
            <div class="base-info">
              <div class="base-title">应用部门：</div>
              <el-input
                @focus="handleChooseDepart"
                :disabled="isEdit || isDetail"
                v-model="organisationNameList"
                style="width: 300px"
                placeholder="请选择"
              ></el-input>
            </div>
          </div>
          <div class="base-content pb0">
            <div class="base-info">
              <div class="base-title"><span style="color: red">*</span>问卷标题：</div>
              <el-input
                maxlength="100"
                v-model.trim="pageForm.surveyTitle"
                style="width: 300px"
                placeholder="示例：关于高血压患者问卷调查"
                :disabled="isDetail"
              ></el-input>
            </div>
            <div class="base-info">
              <div class="base-title"><span style="color: red">*</span>分享问卷:
                <el-tooltip class="item" effect="dark" content="支持分享的问卷不可配置【调研对象、客户类题型、科室、产品、签到】题型" placement="top-start">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
              <div style="padding-left:10px">
                <el-radio-group v-model="pageForm.isSharing" size="mini" :disabled="isDetail">
                  <el-radio :label="'1'">移动端支持二维码分享问卷</el-radio>
                  <el-radio :label="'0'">不支持分享问卷</el-radio>
                </el-radio-group>
                <div style="text-align: left" v-show="pageForm.isSharing == '1'" ><el-checkbox v-model="pageForm.notSelfSubmit" >不允许人员自行填写，仅可分享客户填写</el-checkbox></div>
              
              </div>
            </div>
          </div>
          <div class="base-content pb0">
            <div class="base-info w100f">
              <div class="base-title"  style="padding-right:5px"><span style="color: red">*</span>问卷说明:
                <el-tooltip class="item" effect="dark" content="" placement="top-start">
                  <i class="el-icon-question"></i>
                  <span slot="content">1.问卷填写页面，优先展示下方问卷文章，其次展示问卷说明；<br>2.问卷二维码分享页面，仅展示问卷说明。</span>
                </el-tooltip>
              </div>
        
              <el-input
                :disabled="isDetail"
                type="textarea"
                :rows="5"
                v-model.trim="pageForm.surveyDesc"
                class="w100f"
                maxlength="500"
                placeholder="示例：关于高血压患者问卷调查"
              ></el-input>
           
            </div>
          </div>
          <div class="base-content pb0">
            <div class="base-info">
              <div class="base-title"><span style="color: red">*</span>知情同意书：</div>
              <div>
                <el-radio-group :disabled="isDetail" v-model="pageForm.isOpenProtocol" size="mini">
                  <el-radio :label="'Y'">答卷前需同意患者知情同意书</el-radio>
                  <el-radio :label="'N'">无需同意</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="base-info" v-show="pageForm.isOpenProtocol == 'Y'">
              <div class="base-title"><span style="color: red">*</span>同意书关键字：</div>
              <el-input
                maxlength="100"
                v-model.trim="pageForm.protocolKeyWord"
                style="width: 300px"
                placeholder="请填写"
              ></el-input>
              <span class="base-tips" @click="onPreview">查看说明</span>
            </div>
          </div>
        </div>
        
      </div>
      <!-- 问卷质量检查配置 -->
      <div class="base" style="margin-bottom: 4px">
        <div class="title" style="padding-left: 10px" @click="isExpand2=!isExpand2">
          <div class="title-config">
            <!-- <span class="title-block"></span> -->
            <i v-if="isExpand2" class="el-icon-caret-bottom" ></i>
            <i v-else class="el-icon-caret-right"></i>
            问卷质量检查配置</div>
        </div>
        <el-tabs  v-show="isExpand2" v-model="activeName" type="card">
          <el-tab-pane label="执行规则" name="first">
            <div class="base-content">
              <!-- <div class="base-info w100f">
                <div class="base-title"><span style="color: red">*</span>导入时间限制：</div>
                <div>
                  <el-radio-group v-model="pageForm.qualityCheckConfig.inputDateCheckEnabled" size="mini">
                    <el-radio :label="true">需在任务执行周期导入</el-radio>
                    <el-radio :label="false">不限制</el-radio>
                  </el-radio-group>
                </div>
              </div> -->
            </div>
            <div class="base-content">
              <div class="base-info w100f" style="padding-left: 25px;">
                <el-popover trigger="hover" width="260" placement="top-start">
                  <div>
                    说明：用于控制单人单日导入问卷任务的合理性。
                    <p> 1、例如设置的值为： 2% 至 7%，若该问卷任务目标量为  3000</p>
                    <p> 2、那么公式计算出一个区间：3000 * 2%  至  3000 * 7%  =  【60 至 210】</p>
                    表示：单人单日(问卷填写时间)限制至少导入60 份，且不可超过 210 份
                  </div>
                  <template slot="reference">
                    <i class="el-icon-question"></i>
                  </template>
                </el-popover>
                <div class="base-title"><span style="color: red">*</span>导入答卷数量限制（CRO）：</div>
              
                <div class="other-content">
                  <div class="other-content-list">
                    <el-checkbox v-model="pageForm.qualityCheckConfig.quantityCheckEnabled" :disabled="isDetail"></el-checkbox
                    ><span class="ml10 mr10">单日答卷数的占比必须大于当期任务数的</span>
                    <el-input
                      class="w80"
                      v-model.trim="pageForm.qualityCheckConfig.quantityCheckLowLimit"
                      oninput="value=parseInt(value.replace(/[^\d]/g,''))"
                      type="number"
                      size="mini"
                      min="1"
                      placeholder="占比上限"
                      :disabled="isDetail"
                    ></el-input>
                    <span class="ml10 mr10">%，并小于</span>
                    <el-input
                      class="w80"
                      v-model.trim="pageForm.qualityCheckConfig.quantityCheckUpLimit"
                      oninput="value=value.replace(/[^\d]/g,'')"
                      type="number"
                      size="mini"
                      min="1"
                      placeholder="占比下限"
                      :disabled="isDetail"
                    ></el-input>
                    <span class="ml10 mr10">%</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="base-content">
              <div class="base-info w100f" style="padding-left: 25px;">
                <el-popover trigger="hover"  placement="top-start">
                  <div>
                    限制移动端问卷的提交
                  </div>
                  <template slot="reference">
                    <i class="el-icon-question"></i>
                  </template>
                </el-popover>
                <div class="base-title"><span style="color: red">*</span>填写答卷数量限制：</div>
                <div class="clear-btn ml10" @click="addRule" v-show="!isDetail">
                  <span>添加限制规则</span>
                </div>
                <!-- <div class="other-content">
                  <div class="other-content-list">
                    <el-checkbox v-model="pageForm.qualityCheckConfig.appInputMonthMaxCheckEnabled"></el-checkbox
                    ><span class="ml10 mr10">同核算月同一人员同一天提交同一问卷的份数最多</span>
                    <el-input
                      class="w80"
                      size="mini"
                      v-model="pageForm.qualityCheckConfig.appInputMonthMax"
                      oninput="value=parseInt(value.replace(/[^\d]/g,''))"
                      type="number"
                      min="1"
                    ></el-input>
                    
                    <span class="ml10 mr10">份</span>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="base-content">
              <el-table :data="pageForm.surveyExecuteRules"  tooltip-effect="light" stripe border header-cell-class-name="table_header" style="width: 100%">
              
                <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <!-- 人员条件 -->
                <el-table-column prop="taskContentName" label="人员条件"  width="140" header-align="center"
                  align="center" >
                  <template slot-scope="scope">
                    <el-select size="mini" :disabled="isDetail" v-model="scope.row.personRule" @change="handleSelecConfig(scope.row, scope.$index,'personRule')"
                      placeholder="请选择" clearable>
                      <el-option v-for="(item, index) in getCodeListByKey('人员条件')" :key="index"
                        :label="item.text" :value="item.value"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <!-- 时间条件 -->
                <el-table-column prop="menuName" label="时间条件" header-align="center" width="260" align="center">
                
                  <template slot-scope="scope">
                    <div style="display: flex;align-items:center;">
                      <el-select :disabled="isDetail" size="mini" v-model="scope.row.dateRule" @change="handleSelecConfig(scope.row, scope.$index,'dateRule')"
                        placeholder="请选择" clearable>
                        <el-option v-for="(item, index) in getCodeListByKey('时间条件')" :key="index"
                          :label="item.text" :value="item.value"></el-option>
                      </el-select>
                      <div v-if="scope.row.dateRule" style="display: flex;align-items:center;">
                        <el-input :disabled="isDetail" type="input" size="mini" style="width: 78px; margin-left: 5px;padding:5px" placeholder="请输入"
                          v-model.trim="scope.row.dayNum"  @input="validateInput(scope.row,'dayNum')" @change="handleSelecConfig(scope.row, scope.$index,'dayNum')">
                        </el-input>
                        <div style="margin-left:10px;width:43px">{{ scope.row.dateRule |sjFilters  }}</div>
                      </div>
                      
                    </div>
                    
                  </template>
                </el-table-column>

                <!-- 客户条件 -->
                <el-table-column prop="customerRule" label="客户条件" width="140" header-align="center" align="center">
                  <template slot-scope="scope">
                    <div style="display: flex">
                      
                      <el-select :disabled="isDetail" size="mini" v-model="scope.row.customerRule"
                        placeholder="请输入" clearable @change="handleSelecConfig(scope.row, scope.$index,'customerRule')">
                        <el-option v-for="(item, index) in getCodeListByKey('客户条件')" :key="index"
                        :label="item.text" :value="item.value"></el-option>
                    
                      </el-select>
                    </div>
                    
                  </template>
                </el-table-column>

                <!-- 最大份数 -->
                <el-table-column prop="maxValue" label="最大份数" width="140" header-align="center"  align="center">
                  <template slot-scope="scope">
                    <div style="display: flex;align-items:center;" >
                      <el-input :disabled="isDetail" size="mini" style="width: 128px; margin-right: 5px;" :maxlength="30" placeholder="请输入"
                      v-model.trim="scope.row.maxValue"  @input="validateInput(scope.row,'maxValue')" @change="handleSelecConfig(scope.row, scope.$index,'maxValue')">
                      </el-input>
                    </div>
                  </template>
                </el-table-column>
                <!-- 规则说明 -->
                <el-table-column prop="ruleDesc" label="规则说明" min-width="140" show-overflow-tooltip header-align="center"  align="center">
                  <template slot-scope="scope">
                    <div style="display: flex;align-items:center;">
                      <span>{{ scope.row.ruleDesc }}</span>
                    </div>
                  </template>
                </el-table-column>
                <!-- 拦截提示语 -->
                <el-table-column prop="tips" label="拦截提示语" min-width="140" header-align="center"  align="center">
                  <template slot-scope="scope">
                    <div style="display: flex;align-items:center;">
                      <el-tooltip :content="scope.row.tips" placement="top" effect="light">
                        <el-input :disabled="isDetail" size="mini" style="min-width: 128px; margin-right: 5px; white-space: normal;word-wrap: break-word;" :maxlength="30" placeholder="请输入"
                          v-model.trim="scope.row.tips"  >
                        </el-input>
                      </el-tooltip>
                      
                    </div>
                    
                  </template>
                </el-table-column>
                <el-table-column width="100px" label="操作" header-align="center" align="center">
                  <template slot-scope="scope">
                    <a class="txt-color"  @click="deleteRule(scope.$index)">删除</a>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="签到规则" name="second">
            <div class="base-content">
              <div class="base-info w100f">
                <div class="base-title">现场签到范围：</div>
                <div>
                  <el-input
                    :disabled="isDetail"
                    class="w80"
                    v-model.trim="pageForm.surveyRuleConfig.signLocation.maxRadius"
                    oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    type="text"
                    :min="1"
                    :maxlength="6"
                  ></el-input
                  ><span class="ml10">米</span>
                </div>
              </div>
            </div>
            <div class="base-content">
              <div class="base-info w100f">
                <div class="base-title">范围外签到：</div>
                <div>
                <el-radio-group :disabled="isDetail" v-model="pageForm.surveyRuleConfig.signLocation.allowOutside">
                  <el-radio label="Y">允许范围外签到</el-radio>
                  <el-radio label="N">不允许范围外签到</el-radio>
                </el-radio-group>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="客户权限" name="third">
            <div class="base-content">
              <div class="base-info w100f">
                <div class="base-title">快速建档入口：</div>
                <div>
                  <el-radio-group :disabled="isDetail" v-model="pageForm.surveyRuleConfig.visitRight.isFastAdd">
                    <el-radio label="Y">展示</el-radio>
                    <el-radio label="N">不展示</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <!--重起一行显示完整资料建档、简易建档-->
            <div class="base-content" v-show="pageForm.surveyRuleConfig.visitRight.isFastAdd === 'Y'">
              <div class="base-info w100f">
                <div class="base-title width-block"></div>
                  <!-- v25.1.6 调查问卷需求新完整资料建档。简易建档，展示时显示，默认完整建档-->
                  <div>
                    <el-radio-group :disabled="isDetail" @input="isSimpleFastAddChange" v-model="pageForm.surveyRuleConfig.visitRight.isSimpleFastAdd">
                      <el-radio label="N">完整资料建档</el-radio>
                      <el-radio label="Y">简易建档</el-radio>
                    </el-radio-group>
                  </div>
              </div>
            </div>
            <div class="base-content">
              <div class="base-info w100f" style="padding-left: 25px;">
                <el-popover trigger="hover" width="260" placement="top-start">
                  <div>
                    <p> 1、如果开启，那么移动端选择（药店、商业公司、医院）这类客户名称的时候支持选择底库的数据，其他类型的按照可见权限控制。</p>
                    <p> 2、如果停用，那么移动端选择客户的数据的权限按照客户可见权限配置的规则来。</p>
                  </div>
                  <template slot="reference">
                    <i class="el-icon-question"></i>
                  </template>
                </el-popover>
                <div class="base-title">启用底库数据：</div>
                <div>
                  <el-radio-group :disabled="isDetail" v-model="pageForm.surveyRuleConfig.visitRight.isEsQuery">
                    <!-- <el-radio label="Y">启用</el-radio>
                    <el-radio label="N">停用</el-radio> -->
                    <el-radio 
                     v-for="item in getCodeListByKey('是否')" 
                     :label="item.value">{{ item.text }}
                     
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="base-content" v-if="pageForm.surveyRuleConfig.visitRight.isEsQuery=='N'">
              <div class="base-info w100f">
                <div class="base-title">客户可见权限：</div>
                <div class="dy-table">
                  <div class="dy-table-title">
                    <div>客户类型</div>
                    <div>可见业务员自己数据</div>
                    <div>可见所在销售区域的数据</div>
                    <div>可见所在公司的数据</div>
                  </div>
                  <div class="dy-table-item" v-for="(item, index) in visitRadioList" :key="index">
                    <div class="dy-table-item-label">{{ item.name }}</div>
                    <div class="dy-radio-box">
                      <el-radio
                        :disabled="isDetail"
                        v-model="item.competenceParam"
                        @change="customerChange(item.competenceParam, item)"
                        label="CUSTOMER_YWY"
                        ><span></span
                      ></el-radio>
                    </div>
                    <div class="dy-radio-box">
                      <el-radio
                        :disabled="isDetail"
                        v-model="item.competenceParam"
                        @change="customerChange(item.competenceParam, item)"
                        label="CUSTOMER_XSQY"
                        ><span></span
                      ></el-radio>
                    </div>
                    <div class="dy-radio-box">
                      <el-radio
                        :disabled="isDetail"
                        v-model="item.competenceParam"
                        @change="customerChange(item.competenceParam, item)"
                        label="CUSTOMER_GS"
                        ><span></span
                      ></el-radio>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="产品/科室权限" name="fourth">
            
            <div class="base-content">
              <div class="base-info w100f" style="padding-left: 25px;">
                <el-popover trigger="hover" width="260" placement="top-start">
                  <div>
                    <p> 目前“选择产品”题型仅支持启用底库的产品数据。</p>
                  </div>
                  <template slot="reference">
                    <i class="el-icon-question"></i>
                  </template>
                </el-popover>
                <div class="base-title">产品启用底库数据：</div>
                <div>
                  <el-radio-group v-model="pageForm.surveyRuleConfig.visitRight.isProductEs" disabled>
                    <!-- <el-radio label="Y">启用</el-radio>
                    <el-radio label="N">停用</el-radio> -->
                    <el-radio v-for="item in getCodeListByKey('是否')" :label="item.value">{{ item.text }}</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="base-content">
              <div class="base-info w100f" style="padding-left: 25px;">
                <el-popover trigger="hover" width="260" placement="top-start">
                  <div>
                    <p> 1、如果开启，那么移动端选择武汉链享的科室数据（平台数据）；</p>
                    <p> 2、如果停用，那么移动端选择当前药企的科室数据</p>
                  </div>
                  <template slot="reference">
                    <i class="el-icon-question"></i>
                  </template>
                </el-popover>
                <div class="base-title">科室启用平台：</div>
                <div>
                  <el-radio-group :disabled="pageForm.isPlatformTemplate=='Y' || isDetail" v-model="pageForm.surveyRuleConfig.visitRight.isDeptEs">
                    <!-- <el-radio label="Y">启用</el-radio>
                    <el-radio label="N">停用</el-radio> -->
                    <el-radio v-for="item in getCodeListByKey('是否')" :label="item.value">{{ item.text }}</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        
      </div>
      <!-- 问卷说明配置 -->
      <div class="base" style="margin-bottom: 4px">
        <div class="title" style="padding-left: 10px" @click="isExpand4=!isExpand4">
          <div class="title-config">
            <!-- <span class="title-block"></span> -->
            <i v-if="isExpand4" class="el-icon-caret-bottom"></i>
            <i v-else class="el-icon-caret-right"></i>
            问卷科普资料配置
          </div>
          <!-- <div class="add-btn">
            <img width="20" src="../../assets/images/questionnaire_add.png" alt="" />
            <span>从模板中选择</span>
          </div> -->
        </div>
        <div v-show="isExpand4">
          <!-- <div class="base-content pb0"> -->
            <!-- <div class="base-info w100f"> -->
              <!-- <div class="base-title"><span style="color: red">*</span>问卷说明：</div> -->
              <div class="t-left mt10 font-S14 ml20 mr20">
                问卷文章：
              </div>
              <Editor :value="pageForm.surveyText" @changeData="changeData" :disabled="isDetail" />
              <SurveyVideoUpload v-model="pageForm.videoUrl" :disabled="isDetail" />
              <!-- <el-input
                type="textarea"
                :rows="3"
                v-model.trim="pageForm.surveyDesc"
                class="w100f"
                maxlength="500"
                placeholder="示例：关于高血压患者问卷调查"
              ></el-input> -->
            <!-- </div> -->
          <!-- </div> -->
        </div>
      </div>
      <!-- 问卷题目配置 -->
      <div class="base">
        <div class="title" style="padding-left: 10px">
          <div class="title-config" @click="isExpand3=!isExpand3">
            <!-- <span class="title-block"></span> -->
            <i v-if="isExpand3" class="el-icon-caret-bottom"></i>
            <i v-else class="el-icon-caret-right"></i>
            问卷题目配置
            <span class="title-tip" v-show="pageForm.isSharing == '1'"
              >( 不可配置类型为【调研对象、客户类题型、科室、产品、签到】题型 )</span
            >
          </div>
          <div style="display: flex">
            <div v-if="branchList.length>0" class="clear-btn ml10" @click="seeAllConnect()">
              <span>查看全部题目关联逻辑</span>
            </div>
            <div v-show="isAdd_Update_Copy && !isCurrent" class="clear-btn ml10" @click="clearSubject()">
              <!-- <img width="20" src="../../assets/images/questionnaire_add.png" alt="" /> -->
              <span>清空题目</span>
            </div>
          </div>
        </div>
        
        <div v-show="isExpand3" class="subject-box">
          <div v-for="(item, index) in pageForm.subjectList" :key="index">
            <!-- 单选题 -->
            <div class="subject-box-list" v-show="item.subjectType == '单选题'&&(item.subjectItemType=='1'||item.subjectItemType=='4')&&item.interactType=='1'">
              <div class="subject-list-title mb0">
                <div class="subject-title-left">
                  <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                    item.subjectTitle
                  }}
                  <span v-if="getSubjectLabelText(item)" class="subject-label-tag">{{ getSubjectLabelText(item) }}</span>
                </div>
                <div v-show="(isAdd_Update_Copy || isDetail) && !isCurrent" class="subject-title-right" >
                  <span v-if="isDetail" @click="addSubject(1, item, index, true)">查看</span>
                  <template v-else>
                    <el-tooltip popper-class="tooltip-content" placement="bottom-start" effect="light">
                      <div slot="content">
                        <p>使用说明：</p>
                      <p>1、通过题目关联可以设置分支答卷，比如：用户选择性别男，后面的题目都是关于男性的题目；选择性别女，后面的题目都是关于女性的题目；</p>
                      <p>2、具体操作是在后面的题目关联到前面题目的指定选项（如性别男），答卷时只有选择前面题目的指定选项，后面的题目才会出现。</p>

                    </div>
                    <span @click="addConnect(item, index)" v-if="index != 0"
                      >题目关联 <span class="subject-title-line">|</span></span>
                  </el-tooltip>
                  
                  <span v-if="index + 1 != pageForm.subjectList.length" @click="sortDownField('subject', item, index)"
                    > 下移 <span class="subject-title-line">| </span> </span
                  ><span @click="sortUpField('subject', item, index)" v-if="index != 0"
                    >上移 <span class="subject-title-line">|</span> </span
                  ><span @click="addSubject(1, item, index)"> 编辑 <span class="subject-title-line">| </span> </span
                  ><span class="subject-title-del" @click="delSubject(index)">删除</span>
                  </template>
                </div>
              </div>
              <el-radio-group class="subject-group" v-model="item.inputText" style="line-height: 28px" disabled>
                <div v-for="(items, index1) in item.selectItems" :class="getPadding(item,items, index1)?'pb10':''">
                  <el-radio
                    class="subject-radio mb20 mt15"
                    :key="index1"
                    :label="items.text"
                  ></el-radio>
                  <div style="margin-left: 10px;" v-if="items.isAdd">
                    <el-radio-group
                    v-if="items.subjectItem.subjectType=='单选题'&&(items.subjectItem.subjectItemType=='1'||items.subjectItem.subjectItemType=='4')&&items.subjectItem.interactType=='1'" 
                    class="subject-group" v-model="items.subjectItem.inputText" 
                    style="line-height: 28px" disabled>
                      <el-radio
                        class="subject-radio mb20"
                        v-for="(obj, index2) in items.subjectItem.selectItems"
                        :key="index2"
                        :label="obj.text"
                      >
                      </el-radio>
                    </el-radio-group>
                    <el-checkbox-group
                    v-else-if="items.subjectItem.subjectType == '多选题'&&(items.subjectItem.subjectItemType=='1'||items.subjectItem.subjectItemType=='4')&&items.subjectItem.interactType=='1'"
                    disabled class="subject-group" v-model="items.subjectItem.valueSelect" style="line-height: 28px">
                      <el-checkbox
                        class="subject-radio"
                        v-for="(obj, index2) in items.subjectItem.selectItems"
                        :key="index2"
                        :label="obj.text"
                      ></el-checkbox>
                    </el-checkbox-group>
                    <el-input 
                      v-else-if="items.subjectItem.subjectType=='单行填空题'"
                      class="ml20 w49f" 
                      disabled 
                      type="input" 
                      :placeholder="items.subjectItem.cueWords" 
                      v-model="items.subjectItem.inputText" />
                    <el-input 
                      disabled 
                      v-else-if="items.subjectItem.subjectType=='多行填空题'"
                      class="ml20 w49f"
                      type="textarea" 
                      :placeholder="items.subjectItem.cueWords" 
                      :rows="3" 
                      v-model="items.subjectItem.inputText" />
                    <el-select
                      v-else
                      disabled class="w30f ml20" v-model="value" placeholder="请选择">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </div>
                  <!-- <el-input
                    v-if="items.isAdd&&items.subjectItem.subjectType=='单行填空题'" 
                    class="ml20 w49f" 
                    disabled 
                    type="input" 
                    :placeholder="items.subjectItem.cueWords" 
                    v-model="items.subjectItem.inputText" /> -->
                </div>
              </el-radio-group>
              <p v-if="getTips(item)" class="rule-tips">{{getTips(item)}}</p>
            </div>
            <!-- 多选题 -->
            <div class="subject-box-list" v-show="item.subjectType == '多选题'&&(item.subjectItemType=='1'||item.subjectItemType=='4')&&item.interactType=='1'">
              <div class="subject-list-title mb0">
                <div class="subject-title-left">
                  <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                    item.subjectTitle
                  }}
                  <span v-if="getSubjectLabelText(item)" class="subject-label-tag">{{ getSubjectLabelText(item) }}</span>
                </div>
                <div v-show="(isAdd_Update_Copy || isDetail) && !isCurrent" class="subject-title-right">
                  <span v-if="isDetail" @click="addSubject(1, item, index, true)">查看</span>
                  <template v-else>
                    <span @click="addConnect(item, index)" v-if="index != 0"
                      >题目关联 <span class="subject-title-line">|</span></span>
                    <span v-if="index + 1 != pageForm.subjectList.length" @click="sortDownField('subject', item, index)"
                      >下移 <span class="subject-title-line">| </span> </span
                    ><span @click="sortUpField('subject', item, index)" v-if="index != 0"
                      >上移 <span class="subject-title-line">|</span> </span
                    ><span @click="addSubject(1, item, index)"> 编辑 <span class="subject-title-line">| </span> </span
                    ><span class="subject-title-del" @click="delSubject(index)">删除</span>
                    </template>
                </div>
              </div>
              <el-checkbox-group disabled class="subject-group" v-model="item.valueSelect" style="line-height: 28px">
                <div v-for="(items, index1) in item.selectItems" :class="getPadding(item,items, index1)?'pb10':''">
                  <el-checkbox
                    class="subject-radio mr30"
                    :key="index1"
                    :label="items.text"
                  ></el-checkbox>
                  <div style="margin-left: 10px;" v-if="items.isAdd">
                    <el-radio-group
                    v-if="items.subjectItem.subjectType=='单选题'&&(items.subjectItem.subjectItemType=='1'||items.subjectItem.subjectItemType=='4')&&items.subjectItem.interactType=='1'" 
                    class="subject-group" v-model="items.subjectItem.inputText" 
                    style="line-height: 28px" disabled>
                      <el-radio
                        class="subject-radio mb20"
                        v-for="(obj, index2) in items.subjectItem.selectItems"
                        :key="index2"
                        :label="obj.text"
                      >
                      </el-radio>
                    </el-radio-group>
                    <el-checkbox-group
                    v-else-if="items.subjectItem.subjectType == '多选题'&&(items.subjectItem.subjectItemType=='1'||items.subjectItem.subjectItemType=='4')&&items.subjectItem.interactType=='1'"
                    disabled class="subject-group" v-model="items.subjectItem.valueSelect" style="line-height: 28px">
                      <el-checkbox
                        class="subject-radio"
                        v-for="(obj, index2) in items.subjectItem.selectItems"
                        :key="index2"
                        :label="obj.text"
                      ></el-checkbox>
                    </el-checkbox-group>
                    <el-input 
                      v-else-if="items.subjectItem.subjectType=='单行填空题'"
                      class="ml20 w49f" 
                      disabled 
                      type="input" 
                      :placeholder="items.subjectItem.cueWords" 
                      v-model="items.subjectItem.inputText" />
                    <el-input 
                      disabled 
                      v-else-if="items.subjectItem.subjectType=='多行填空题'"
                      class="ml20 w49f"
                      type="textarea" 
                      :placeholder="items.subjectItem.cueWords" 
                      :rows="3" 
                      v-model="items.subjectItem.inputText" />
                    <el-select
                      v-else
                      disabled class="w30f ml20" v-model="value" placeholder="请选择">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                  </div>
                  <!-- <el-input
                    v-if="items.isAdd&&items.subjectItem.cueWords"  
                    class="ml20 w49f" 
                    disabled 
                    type="input" 
                    :placeholder="items.subjectItem.cueWords" 
                    v-model="items.subjectItem.inputText" /> -->
                </div>
                
              </el-checkbox-group>
              <p v-if="getTips(item)" class="rule-tips">{{getTips(item)}}</p>
            </div>
            <!-- 单行填空题 -->
            <div class="subject-box-list pb10" v-show="item.subjectType == '单行填空题'">
              <div class="subject-list-title">
                <div class="subject-title-left">
                  <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                    item.subjectTitle
                  }}
                  <span v-if="getSubjectLabelText(item)" class="subject-label-tag">{{ getSubjectLabelText(item) }}</span>
                </div>
                <div v-show="(isAdd_Update_Copy || isDetail) && !isCurrent" class="subject-title-right">
                  <span v-if="isDetail" @click="addSubject(1, item, index, true)">查看</span>
                  <template v-else>
                    <span @click="addConnect(item, index)" v-if="index != 0"
                      >题目关联 <span class="subject-title-line">|</span></span>
                    <span v-if="index + 1 != pageForm.subjectList.length" @click="sortDownField('subject', item, index)"
                      >下移 <span class="subject-title-line">| </span> </span
                    ><span @click="sortUpField('subject', item, index)" v-if="index != 0"
                      >上移 <span class="subject-title-line">|</span> </span
                    ><span @click="addSubject(1, item, index)"> 编辑 <span class="subject-title-line">| </span> </span
                    ><span class="subject-title-del" @click="delSubject(index)">删除</span>
                  </template>
                </div>
              </div>
              <el-input class="ml20 w49f" disabled type="input" placeholder="请输入" v-model="item.inputText" />
              <p v-if="getTips(item)" class="rule-tips">{{getTips(item)}}</p>
            </div>
            <!-- 多行填空题 -->
            <div class="subject-box-list pb10" v-show="item.subjectType == '多行填空题'">
              <div class="subject-list-title">
                <div class="subject-title-left">
                  <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                    item.subjectTitle
                  }}
                  <span v-if="getSubjectLabelText(item)" class="subject-label-tag">{{ getSubjectLabelText(item) }}</span>
                </div>
                <div v-show="(isAdd_Update_Copy || isDetail) && !isCurrent" class="subject-title-right">
                  <span v-if="isDetail" @click="addSubject(1, item, index, true)">查看</span>
                  <template v-else>
                    <span @click="addConnect( item, index)" v-if="index != 0"
                      >题目关联 <span class="subject-title-line">|</span></span>
                    <span v-if="index + 1 != pageForm.subjectList.length" @click="sortDownField('subject', item, index)"
                      >下移 <span class="subject-title-line">| </span> </span
                    ><span @click="sortUpField('subject', item, index)" v-if="index != 0"
                      >上移 <span class="subject-title-line">|</span> </span
                    ><span @click="addSubject(1, item, index)"> 编辑 <span class="subject-title-line">| </span> </span
                    ><span class="subject-title-del" @click="delSubject(index)">删除</span>
                  </template>
                </div>
              </div>
              <el-input
                disabled
                class="ml20 w96f"
                type="textarea"
                placeholder="请输入"
                :rows="5"
                v-model="item.inputText"
              />
              <p v-if="getTips(item)" class="rule-tips">{{getTips(item)}}</p>
            </div>
            <!-- 选择区域 -->
            <div class="subject-box-list pb10" v-show="item.subjectType == '选择区域'">
              <div class="subject-list-title">
                <div class="subject-title-left">
                  <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                    item.subjectTitle
                  }}
                  <span v-if="getSubjectLabelText(item)" class="subject-label-tag">{{ getSubjectLabelText(item) }}</span>
                </div>
                <div v-show="(isAdd_Update_Copy || isDetail) && !isCurrent" class="subject-title-right">
                  <span v-if="isDetail" @click="addSubject(1, item, index, true)">查看</span>
                  <template v-else>
                    <span @click="addConnect(item, index)" v-if="index != 0"
                      >题目关联 <span class="subject-title-line">|</span></span>
                    <span v-if="index + 1 != pageForm.subjectList.length" @click="sortDownField('subject', item, index)"
                      >下移 <span class="subject-title-line">| </span> </span
                    ><span @click="sortUpField('subject', item, index)" v-if="index != 0"
                      >上移 <span class="subject-title-line">|</span> </span
                    ><span @click="addSubject(1, item, index)"> 编辑 <span class="subject-title-line">| </span> </span
                    ><span class="subject-title-del" @click="delSubject(index)">删除</span>
                  </template>
                </div>
              </div>
              <el-select disabled class="w30f ml20" v-model="value" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <p v-if="getTips(item)" class="rule-tips">{{getTips(item)}}</p>
            </div>
            <!-- 调研对象 -->
            <div class="subject-box-list" v-show="item.subjectType == '调研对象'">
              <div class="subject-list-title">
                <div class="subject-title-left">
                  <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                    item.subjectTitle
                  }}
                  <span v-if="getSubjectLabelText(item)" class="subject-label-tag">{{ getSubjectLabelText(item) }}</span>
                </div>
                <div v-show="(isAdd_Update_Copy || isDetail) && !isCurrent" class="subject-title-right">
                  <span v-if="isDetail" @click="addSubject(1, item, index, true)">查看</span>
                  <template v-else>
                    <span @click="addConnect(item, index)" v-if="index != 0"
                      >题目关联 <span class="subject-title-line">|</span></span>
                    <span v-if="index + 1 != pageForm.subjectList.length" @click="sortDownField('subject', item, index)"
                      >下移 <span class="subject-title-line">| </span> </span
                    ><span @click="sortUpField('subject', item, index)" v-if="index != 0"
                      >上移 <span class="subject-title-line">|</span> </span
                    ><span @click="addSubject(1, item, index)"> 编辑 <span class="subject-title-line">| </span> </span
                    ><span class="subject-title-del" @click="delSubject(index)">删除</span>
                  </template>
                </div>
              </div>
              <el-radio-group class="subject-group" v-model="item.inputText" style="line-height: 28px" disabled>
                <el-radio
                  class="subject-radio mb20 mt15"
                  v-for="(items, index1) in item.selectItems"
                  :key="index1"
                  :label="items.text"
                ></el-radio>
              </el-radio-group>
              <p v-if="getTips(item)" class="rule-tips">{{getTips(item)}}</p>
            </div>
            <!-- 客户名称 -->
            <div class="subject-box-list pb10"  v-show="item.subjectType == '客户名称'">
              <div class="subject-list-title">
                <div class="subject-title-left">
                  <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                    item.subjectTitle
                  }}
                  <span v-if="getSubjectLabelText(item)" class="subject-label-tag">{{ getSubjectLabelText(item) }}</span>
                </div>
                <div v-show="(isAdd_Update_Copy || isDetail) && !isCurrent" class="subject-title-right">
                  <span v-if="isDetail" @click="addSubject(1, item, index, true)">查看</span>
                  <template v-else>
                    <span @click="addConnect(item, index)" v-if="index != 0"
                      >题目关联 <span class="subject-title-line">|</span></span>
                    <span v-if="index + 1 != pageForm.subjectList.length" @click="sortDownField('subject', item, index)"
                      >下移 <span class="subject-title-line">| </span> </span
                    ><span @click="sortUpField('subject', item, index)" v-if="index != 0"
                      >上移 <span class="subject-title-line">|</span> </span
                    ><span @click="addSubject(1, item, index)"> 编辑 <span class="subject-title-line">| </span> </span
                    ><span class="subject-title-del" @click="delSubject(index)">删除</span>
                  </template>
                </div>
              </div>
              <el-select disabled class="w30f ml20" v-model="value" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <p v-if="getTips(item)" class="rule-tips">{{getTips(item)}}</p>
            </div>
            <!-- 新题型-->
            <div
              class="subject-box-list pb10"
              v-show="item.subjectType == '时间'||
              item.subjectType == '年月'||
              item.subjectType == '年月日'||
              item.subjectType == '填写日期'||
              (item.subjectType == '单选题'&&item.subjectItemType!='1'&&item.subjectItemType!='4')||
              (item.subjectType == '单选题'&&item.interactType=='2')||
              (item.subjectType == '多选题'&&item.subjectItemType!='1'&&item.subjectItemType!='4')||
              (item.subjectType == '多选题'&&item.interactType=='2')||
              item.subjectType == '定位签到'||
              item.subjectType == '选择医疗机构'||
              item.subjectType == '选择等级医院'||
              item.subjectType == '选择基层医疗'||
              item.subjectType == '选择药店'||
              item.subjectType == '选择商业公司'
              "
              >
              <div class="subject-list-title">
                <div class="subject-title-left">
                  <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                    item.subjectTitle
                  }}
                  <span v-if="getSubjectLabelText(item)" class="subject-label-tag">{{ getSubjectLabelText(item) }}</span>
                </div>
                <div v-show="(isAdd_Update_Copy || isDetail) && !isCurrent" class="subject-title-right">
                  <span v-if="isDetail" @click="addSubject(1, item, index, true)">查看</span>
                  <template v-else>
                    <span @click="addConnect( item, index)" v-if="index != 0"
                      >题目关联 <span class="subject-title-line">|</span></span>
                    <span v-if="index + 1 != pageForm.subjectList.length" @click="sortDownField('subject', item, index)"
                      >下移 <span class="subject-title-line">| </span> </span
                    ><span @click="sortUpField('subject', item, index)" v-if="index != 0"
                      >上移 <span class="subject-title-line">|</span> </span
                    ><span @click="addSubject(1, item, index)"> 编辑 <span class="subject-title-line">| </span> </span
                    ><span class="subject-title-del" @click="delSubject(index)">删除</span>
                  </template>
                </div>
              </div>
              <!-- <el-input class="ml20 w49f" disabled type="input" placeholder="请输入" v-model="item.inputText" /> -->
              <el-select disabled class="w30f ml20" v-model="value" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <p v-if="getTips(item)" class="rule-tips">{{getTips(item)}}</p>
            </div>
            <!-- 上传照片 -->
            <div class="subject-box-list pb10" v-show="item.subjectType.indexOf('上传照片') > -1">
              <div class="subject-list-title">
                <div class="subject-title-left">
                  <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、【{{ item.subjectType }}】{{
                    item.subjectTitle
                  }}
                  <span v-if="getSubjectLabelText(item)" class="subject-label-tag">{{ getSubjectLabelText(item) }}</span>
                </div>
                <div v-show="(isAdd_Update_Copy || isDetail) && !isCurrent" class="subject-title-right">
                  <span v-if="isDetail" @click="addSubject(1, item, index, true)">查看</span>
                  <template v-else>
                    <span @click="addConnect( item, index)" v-if="index != 0"
                      >题目关联 <span class="subject-title-line">|</span></span>
                    <span v-if="index + 1 != pageForm.subjectList.length" @click="sortDownField('subject', item, index)"
                      >下移 <span class="subject-title-line">| </span> </span
                    ><span @click="sortUpField('subject', item, index)" v-if="index != 0"
                      >上移 <span class="subject-title-line">|</span> </span
                    ><span @click="addSubject(1, item, index)"> 编辑 <span class="subject-title-line">| </span> </span
                    ><span class="subject-title-del" @click="delSubject(index)">删除</span>
                  </template>
                </div>
              </div>
              <div class="avatar-uploader ml20">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
              <p v-if="getTips(item)" class="rule-tips">{{getTips(item)}}</p>
            </div>
            
          
          </div>
           <div v-show="isAdd_Update_Copy && !isCurrent" class="subject-add-box">
            <div class="subject-add-btn mr10" @click="addSubject(2)"><span>+</span>手动添加</div>
            <div class="subject-add-btn" @click="addSubject(3)"><span>+</span>自动添加</div>
          </div>
        </div>
          
        

        
      </div>
      <div v-show="isExpand3"  class="subject-icon-btn">
        <i class="el-icon-arrow-up" @click="subjectScroll(1)" style="border-bottom: 1px solid #bdbdbd;"></i>
        <i class="el-icon-arrow-down" @click="subjectScroll(-1)"></i>
      </div>
      <!-- start of 流程审批 -->
      <div class="back-color-fff mt-4">
        <div class="flow">
          <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
        </div>
      </div>
      <!-- end of 流程审批 -->
      <div class="back-color-fff submit_btn_wrap" v-show="!isDetail">
        <el-button v-show="!isEdit||pageForm.isDraft=='Y'" size="mini" type="info"  @click="remindData(pageForm,1)"
          >保存，暂不提交</el-button
        >
        <el-button size="mini" type="info"  @click="mobileView()"
          >移动端预览</el-button
        >
        <el-button size="mini" type="info"  @click="remindData(pageForm)">提交</el-button>
        <el-button size="mini" type="white"  @click="$router.go(-1)"
          >取消</el-button
        >
      </div>
      <div class="back-color-fff submit_btn_wrap" v-show="isDetail">
        <el-button
          v-if="getBtnState('approval', pageForm) == 'approval'"
          type="danger" 
          size="mini" 
          @click="rejectDialogClick"
        >
          驳回
        </el-button>
        <el-button
          v-if="getBtnState('approval', pageForm) == 'approval'"
          type="primary" 
          size="mini" 
          @click="passDialogClick"
        >
          通过
        </el-button>
        <el-button
          v-if="getBtnState('revoke', pageForm) == 'revoke'"
          type="primary" 
          size="mini" 
          @click="toRevoke"
        >
          撤销
        </el-button>
        <el-button
          size="mini" 
          type="white" 
          @click="$router.go(-1)"
        >
          取消
        </el-button>
      </div>
    </div>
    <!-- 弹窗-选择部门 -->
    <el-dialog title="选择部门" :visible.sync="departmentVisible" width="70%" center :close-on-click-modal="false">
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model.trim="filterText" class="ipt-sty mt15" placeholder="请输入部门名称"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree
              class="filter-tree"
              :data="areaData"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @check="handleNodeClick1"
              :check-strictly="true"
              show-checkbox
              ref="tree"
              node-key="guid"
              v-if="departmentVisible"
            >
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}个部门</p>
            <el-button size="medium" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px"
              >批量删除</el-button
            >
            <el-table
              :data="departmentList"
              border
              height="280px"
              style="width: 100%"
              @selection-change="handleSelectionChange1"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="organisationName"
                label="名称"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="departmentVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="departmentSure()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 弹窗-添加题目 -->
    <el-dialog width="960px" :visible.sync="subjectVisible" :close-on-click-modal="false">
      <div slot="title" class="dialog-title">
        <span :class="subjectType == 1 ? 'dialog-title-active' : ''" @click="subjectType = 1">{{
          subjectReadonly ? '查看题目' : (subjectEdit ? '编辑题目' : '手动添加题目')
        }}</span
        ><span v-show="!subjectEdit && !subjectReadonly" :class="subjectType == 2 ? 'dialog-title-active' : ''" @click="subjectType = 2"
          >批量选题</span
        >
      </div>
      <!-- 手动添加题目 -->
      <div v-show="subjectType == 1">
        <div class="subject-title">
          <div class="subject-title-name"><span></span>问题基础配置</div>
        </div>
        <el-row :gutter="24">
          <el-col :span="19"
            ><div class="search-area-div" style="width: 110px; font-size: 14px">
              <span class="fontC-red">*</span>题目标题：
            </div>
            <el-input
              type="textarea"
              :rows="2"
              style="width: 580px"
              placeholder="请输入"
              v-model.trim="subjectForm.subjectTitle"
              maxlength="100"
              show-word-limit
              :disabled="subjectReadonly"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mt15">
          <el-col :span="10"
            ><div class="search-area-div" style="width: 110px; font-size: 14px">
              <span class="fontC-red">*</span>题目类型：
            </div>
            <el-select
              style="width: 225px"
              v-model="subjectForm.subjectType"
              filterable
              :disabled="subjectForm.disabledChange || subjectReadonly"
              placeholder="请选择"
              @change="subjectTypeChange"
            >
              <el-option
                v-for="(item, index) in pageForm.isSharing == '1' ? subjectTypeSharing : subjectTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <span class="item-tips" v-if="subjectForm.subjectType=='填写日期'">
              为了更好的体验，建议该题型放在第1题
            </span>
          </el-col>
          <el-col :span="6"
            ><div class="search-area-div" style="width: 110px; font-size: 14px">
              <span class="fontC-red">*</span>排序：
            </div>
            <el-input 
             v-model.trim="subjectForm.orderNum" 
             :disabled="subjectForm.disabledOrderNum || subjectReadonly"
             @input="handleInput(subjectForm.orderNum)"
             class="fl">
            </el-input>
          </el-col>
          <el-col :span="8"
            ><div class="search-area-div" style="width: 110px; font-size: 14px">
              <span class="fontC-red">*</span>是否必填：
            </div>
            <el-radio-group :disabled="subjectForm.subjectType == '填写日期' || subjectReadonly" v-model="subjectForm.isRequired" class="fl" style="line-height: 45px">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </el-col>
          
        </el-row>
        <el-row :gutter="24" class="mt15" v-if="subjectForm.subjectType == '单选题'||subjectForm.subjectType == '多选题'">
          <el-col :span="10" 
            ><div class="search-area-div" style="width: 110px; font-size: 14px">
              <span class="fontC-red">*</span>题型分类：
            </div>
            <el-select
              style="width: 225px"
              v-model="subjectForm.subjectItemType"
              filterable
              placeholder="请选择"
              :disabled="subjectForm.disabledChange || subjectReadonly"
              @change="subjectItemTypeChange"
            >
              <el-option
                v-for="(item, index) in pageForm.isSharing == '1' ? subjectItemTypeSharing : getCodeListByKey('题型分类')"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="14" v-if="subjectForm.subjectItemType=='4'"
            ><div class="search-area-div" style="width: 110px; font-size: 14px">
              <span class="fontC-red">*</span>字典名称：
            </div>
            <el-select
              class="fl"
              v-model="subjectForm.dictGuid"
              filterable
              placeholder="请选择"
              :disabled="subjectForm.disabledChange || subjectReadonly"
              @change="dictChange(subjectForm.dictGuid)"
            >
              <el-option
                v-for="(item, index) in dictList"
                :key="index"
                :label="item.dictTypeName"
                :value="item.guid"
              ></el-option>
            </el-select>
            <!-- 字典（有二级） 筛选  -->
            <div v-if="subjectForm.interactType=='2'&&subjectForm.hasChild" class="fl ml10" style="line-height: 36px;">
              <el-checkbox v-model="subjectForm.isSupportAll"></el-checkbox
                ><span class="ml10 fontC-red">支持选字典“全部”选项</span>
            </div>
            
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mt15" v-if="subjectForm.subjectItemType=='1'||subjectForm.subjectItemType=='4'">
          <el-col :span="10"
            ><div class="search-area-div" style="width: 110px; font-size: 14px">
              <span class="fontC-red">*</span>交互方式：
            </div>
            <el-select
              style="width: 225px"
              v-model="subjectForm.interactType"
              filterable
              :disabled="subjectForm.disabledChange || subjectReadonly"
              placeholder="请选择"
              @change="interactTypeChange"
            >
              <el-option
                v-for="(item, index) in getCodeListByKey('交互方式')"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <!-- 选择区域类型的验证方式输入 -->
        <el-row :gutter="24" class="mt15" v-if="subjectForm.subjectType == '选择区域' &&  pageForm.isSharing == '0'">
          <el-col :span="10">
            <div class="search-area-div" style="width: 110px; font-size: 14px">
              <span class="fontC-red">*</span>验证方式输入：
            </div>
            <el-select
              style="width: 225px"
              v-model="subjectForm.validateGuid"
              filterable
              placeholder="请选择"
              :disabled="subjectReadonly"
            >
              <el-option
                v-for="item in  validateList"
                :key="item.validateRuleGuid"
                :label="item.validName"
                :value="item.validateRuleGuid"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mt15" 
         v-if="subjectForm.subjectType == '单行填空题'||
         subjectForm.subjectType == '年月'||
         subjectForm.subjectType == '年月日'||
         subjectForm.subjectType == '填写日期'||
         subjectForm.subjectType == '定位签到'
         " >
          <el-col :span="10"
            ><div class="search-area-div" style="width: 110px; font-size: 14px">
              <span class="fontC-red">*</span>验证输入方式：
            </div>
            <el-select
              style="width: 225px"
              v-model="subjectForm.validateGuid"
              filterable
              placeholder="请选择"
              :disabled="subjectReadonly"
            >
              <el-option
                v-for="item in  validateList"
                :key="item.validateRuleGuid"
                :label="item.validName"
                :value="item.validateRuleGuid"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="14">
            <div class="search-area-div" style="width: 110px; font-size: 14px">
              <el-popover trigger="hover" width="260" placement="top-start">
                <div>{{ '如果该问卷收集的此项内容不允许重复，可开启这个校验。' }}</div>
                <template slot="reference">
                  <i class="el-icon-question"></i>
                </template>
              </el-popover>
              <span class="fontC-red">*</span>唯一性校验：
            </div>
            <el-radio-group v-model="subjectForm.isValidateUnique" class="fl" style="line-height: 45px">
              <el-radio label="Y">校验</el-radio>
              <el-radio label="N">不校验</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mt15">
          <el-col :span="10"
            ><div class="search-area-div" style="width: 110px; font-size: 14px">
              <span class="fontC-red">*</span>题目标签：
            </div>
            <el-cascader
              style="width: 225px;"
              :disabled="subjectReadonly"
              v-model="subjectForm.subjectLabelGuid"
              :options="labelAddList"
              filterable
              :show-all-levels="false"
              :props="{
                value: 'guid',
                label: 'labelName',
                children: 'children',
                multiple: false,
                emitPath: false,
              }"
              clearable
              placeholder="请选择"
            >
            </el-cascader>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mt15"
        v-if="subjectForm.subjectType.indexOf('上传照片') > -1"
        >
          <el-col :span="24" 
            ><div class="search-area-div" style="width: 110px; font-size: 14px">
              <span class="fontC-red"></span>
              <el-popover trigger="hover" width="300" placement="right-start">
                <div>{{ '用于提供给终端服务人员在做任务时的参考图' }}</div>
                <template slot="reference">
                  <i class="el-icon-question"></i>
                </template> 
              </el-popover>
              示例图片：
            </div>
            <div class="dialogCon-describe file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="5"
                :headers="token"
                :on-exceed="handleExceed"
                accept=".jpg,.png,.jpeg"
                :on-remove="handleBillRemove"
                :http-request="uploadBillImage"
                :file-list="subjectForm.pictUrl"
              >
                <div class="import-btn-tips ml15">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >点击上传</el-button
                  >
                  <div slot="tip" class="import-step-tip"> 
                    {{ '最大不超过 5M 的图片，支持jpg、png、jpeg等图片格式' }}
                  </div>
                </div>
                <div slot="file" slot-scope="{ file }" v-show="false">

                </div>

              </el-upload>
            </div>
          </el-col>
        </el-row>
        <div  class="picture-box">
          <div class="flex" v-for="file in subjectForm.pictUrl"  v-if="subjectForm.pictUrl && subjectForm.pictUrl.length > 0">
            <div class="file-name nowrap-ellipsis">{{ file.fileName }}</div>
            <div class="flex">
              <a
                @click="handlePictureCardPreview(file)"
                style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                download="FileName"
                class="downFile"
                >查看</a
              >
              <a
                v-if="!subjectReadonly"
                @click="handleBillRemove(file)"
                style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                download="FileName"
                class="downFile"
                >删除</a
              >
            </div>
          </div>
        </div>
        
        <div
          class="subject-title mt30"
          v-show="
            ((subjectForm.subjectType == '单选题' ||
            subjectForm.subjectType == '多选题')&& (subjectForm.subjectItemType=='1'||subjectForm.subjectItemType=='4')) ||
            subjectForm.subjectType == '调研对象'
          "
        >
          <div class="subject-title-name"><span></span>题目选项配置</div>
          <div class="subject-add-btn" v-if="subjectForm.subjectItemType!=='4' && !subjectReadonly" @click="addSubjectItem">
            <span>+</span>
            添加选项
          </div>
        </div>
        <el-table
          :data="subjectForm.selectItems"
          style="width: 100%"
          v-show="
            ((subjectForm.subjectType == '单选题' ||
            subjectForm.subjectType == '多选题')&& (subjectForm.subjectItemType=='1'||subjectForm.subjectItemType=='4')) ||
            subjectForm.subjectType == '调研对象'
          "
        >
          <template slot="empty">
            <span>暂无选项</span>
          </template>
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="选项名称">
            <template slot-scope="scope">
              <el-select
                :disabled="subjectReadonly"
                v-if="subjectForm.subjectType == '调研对象'"
                class="fl"
                v-model="scope.row.value"
                placeholder="请选择"
                @change="changeSubjectObj(scope.row)"
              >
                <el-option v-for="item in targetOption" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select
                :disabled="subjectReadonly"
                v-else-if="subjectForm.subjectItemType=='4'"
                class="fl"
                disabled
                v-model="scope.row.value"
                placeholder="请选择"
              >
                <el-option v-for="item in targetOption" :key="item.value" :label="item.text" :value="item.value">
                </el-option>
              </el-select>
              <el-input v-else :disabled="subjectReadonly" class="fl" type="input" placeholder="请输入" v-model.trim="scope.row.text" />
            </template>
          </el-table-column>
          <el-table-column v-if="(subjectForm.subjectType == '单选题' || subjectForm.subjectType == '多选题')&&(subjectForm.subjectItemType=='1'||subjectForm.subjectItemType=='4')&&subjectForm.interactType=='1'" prop="address" label="是否追加子答案项" width="180">
            <template slot-scope="scope">
              <div class="subject-select">
                <el-checkbox :disabled="subjectReadonly" @change="addChange(scope.row)" v-model="scope.row.isAdd">追加</el-checkbox>
                <el-checkbox :disabled="!scope.row.isAdd || subjectReadonly" v-model="scope.row.isAddWrite">必填</el-checkbox>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column v-if="subjectForm.interactType!='2'" prop="address" label="是否正确答案" width="120">
            <template slot-scope="scope">
              <div class="subject-select">
                <div :class="scope.row.isCorrect == true ? 'true-active' : ''" @click="subjectIsTrue(1, scope.$index)">
                  正确
                </div>
                <div
                  :class="scope.row.isCorrect == false ? 'false-active' : ''"
                  @click="subjectIsTrue(2, scope.$index)"
                >
                  错误
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column  v-if="subjectForm.interactType!='2'" label="排序" width="100">
            <template slot-scope="scope">
              <div class="opreateIcon">
                <i
                  v-if="scope.$index + 1 != subjectForm.selectItems.length"
                  class="el-icon-sort-down"
                  @click="sortDownField('field', scope.row, scope.$index)"
                ></i>
                <i
                  v-if="scope.$index != 0"
                  class="el-icon-sort-up"
                  @click="sortUpField('field', scope.row, scope.$index)"
                ></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" v-if="subjectForm.interactType!='2'||subjectForm.subjectItemType=='1'" label="操作" width="160">
            <template slot-scope="scope">
              <a class="txt-color" v-if="subjectForm.subjectItemType!=='4'" @click="subjectFieldDel(scope.$index)">删除  </a>
              <span class="txt-color" v-if="subjectForm.subjectItemType!=='4'&&scope.row.isAdd">|</span>
              <a class="txt-color"  v-if="scope.row.isAdd" @click="setSelectAdd(scope.row,scope.$index)"> 追加子答案规则</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 批量选题 -->
      <div class="choose-subject-box" v-show="subjectType == 2">
        <div class="choose-subject-left">
          <el-input class="mb15" placeholder="请输入" v-model.trim="surveyTitle" @change="getSurveyList">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <div
            :class="!surveyGuid ? 'choose-left-list choose-left-active' : 'choose-left-list'"
            @click="clickSurveyList()"
          >
            全部题目
          </div>
          <div
            :class="item.guid == surveyGuid ? 'choose-left-list choose-left-active' : 'choose-left-list'"
            v-for="(item, index) in surveyList"
            :key="index"
            @click="clickSurveyList(item.guid)"
          >
            {{ item.surveyTitle }}
          </div>
        </div>
        <div class="choose-subject-right">
          <el-row :gutter="24" class="mb15">
            <el-col :span="11"
              ><div class="search-area-div" style="width: 80px; font-size: 14px">题目标签：</div>
              <el-cascader
                style="width: 200px;"
                :disabled="subjectReadonly"
                v-model="page.labelGuid"
                :options="labelList"
                filterable
                :show-all-levels="false"
                :props="{
                  value: 'guid',
                  label: 'labelName',
                  children: 'children',
                  multiple: false,
                  emitPath: false,
                }"
                clearable
                placeholder="请选择"
              >
              </el-cascader>
              <!-- <el-input style="width: 200px" placeholder="请输入" v-model="page.labelName"></el-input> -->
            </el-col>
            <el-col :span="11"
              ><div class="search-area-div" style="width: 80px; font-size: 14px">题目标题：</div>
              <el-input style="width: 200px" placeholder="请输入" v-model.trim="page.subjectTitle"></el-input>
            </el-col>
          </el-row>
          <el-row :gutter="24" class="mb15">
            <el-col :span="11"
              ><div class="search-area-div" style="width: 80px; font-size: 14px">题目类型：</div>
              <el-select style="width: 200px" v-model="page.subjectType" filterable placeholder="请选择">
                <el-option
                  v-for="(item, index) in subjectTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="13">
              <el-button size="medium" @click="getSubject" type="info">搜索</el-button>
              <el-button size="medium" @click="emptySelectSubject" type="danger">清空</el-button>
            </el-col>
          </el-row>
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%; margin-bottom: 20px"
            border
            @selection-change="handleSelectionChange"
            v-loading="tableLoading"
            :row-key="getRowKeys"
          >
            <el-table-column
              type="selection"
              :reserve-selection="true"
              width="60"
              header-align="center"
              align="center"
              :selectable="selectDisableRoom"
            ></el-table-column>
            <el-table-column label="序号" width="70">
              <template slot-scope="scope">
                {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="labelName" label="题目标签" header-align="left" align="left" show-overflow-tooltip>
              <template slot-scope="scope"> {{ getSubjectLabelText(scope.row) }} </template>
            </el-table-column>
            <el-table-column
              prop="subjectTitle"
              label="题目标题"
              header-align="left"
              align="left"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="subjectType" label="题目类型" header-align="left" align="left" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="selectItems" label="题目选项" header-align="left" align="left" show-overflow-tooltip>
              <template slot-scope="scope"> {{ getSelectItems(scope.row.selectItems) }} </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pt pb back-color-fff"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 100, 200]"
            :current-page="page.pageIndex"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.totalRows"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="subjectVisible = false">取 消</el-button>
        <el-button v-show="!subjectReadonly" size="medium" type="info" @click="subjectSubmit">确 定</el-button>
      </span>
     
    </el-dialog>
    <!-- 弹窗-设置选择题追加填空规则 -->
    <el-dialog width="760px" custom-class="childDialog" :visible.sync="selectAddVisible" >
        <div slot="title" style="text-align:left" >
          <span class="dialog-title-active">追加子答案规则</span>
        </div>
        <el-row :gutter="24" class="mt15">
          
          <div class="search-area-div" style="width: 110px; font-size: 14px">
            <span class="fontC-red">*</span>题目类型：
          </div>
          <el-select
            :disabled="subjectReadonly"
            class="fl"
            v-model="childForm.subjectType"
            filterable
            placeholder="请选择"
            @change="childTypeChange"
          >
            <el-option
              v-for="(item, index) in pageForm.isSharing == '1' ? childTypeSharing : childTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-row>
        <el-row :gutter="24" class="mt15" v-if="childForm.subjectType == '单选题'||childForm.subjectType == '多选题'">
            <div class="search-area-div" style="width: 110px; font-size: 14px">
              <span class="fontC-red">*</span>题型分类：
            </div>
            <el-select
              :disabled="subjectReadonly"
              class="fl"
              v-model="childForm.subjectItemType"
              filterable
              placeholder="请选择"
              @change="subjectItemTypeChange('child')"
            >
              <el-option
              v-for="(item, index) in pageForm.isSharing == '1' ? subjectItemTypeSharing : getCodeListByKey('题型分类')"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-row>
        <el-row :gutter="24" class="mt15" v-if="(childForm.subjectType == '单选题'||childForm.subjectType == '多选题')&&childForm.subjectItemType=='4'">
          <div class="search-area-div" style="width: 110px; font-size: 14px">
            <span class="fontC-red">*</span>字典名称：
          </div>
          <el-select
            :disabled="subjectReadonly"
            class="fl"
            v-model="childForm.dictGuid"
            filterable
            placeholder="请选择"
            @change="dictChange(childForm.dictGuid,'child')"
          >
            <el-option
              v-for="(item, index) in dictList"
              :key="index"
              :label="item.dictTypeName"
              :value="item.guid"
            ></el-option>
          </el-select>
           <!-- 字典（有二级） 筛选  -->
           <div v-if="childForm.interactType=='2'&&childForm.hasChild" class="fl ml10" style="line-height: 36px;">
              <el-checkbox v-model="childForm.isSupportAll"></el-checkbox
                ><span class="ml10 fontC-red">支持选字典“全部”选项</span>
            </div>
        </el-row>
        <el-row :gutter="24" class="mt15" v-if="(childForm.subjectType == '单选题'||childForm.subjectType == '多选题')&&(childForm.subjectItemType=='1'||childForm.subjectItemType=='4')">
          <div class="search-area-div" style="width: 110px; font-size: 14px">
            <span class="fontC-red">*</span>交互方式：
          </div>
          <el-select
            :disabled="subjectReadonly"
            class="fl"
            v-model="childForm.interactType"
            filterable
            @change="interactTypeChange('child')"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in getCodeListByKey('交互方式')"
              :key="index"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-row>
        <el-row :gutter="24" class="mt15"
        v-if="childForm.subjectType == '单行填空题'||
        childForm.subjectType == '年月'||
        childForm.subjectType == '年月日'||
        childForm.subjectType == '定位签到'
        " >
          
            <div class="search-area-div" style="width: 110px; font-size: 14px">
              <span class="fontC-red">*</span>验证输入方式：
            </div>
            <el-select
              :disabled="subjectReadonly"
              class="fl"
              v-model="childForm.validateGuid"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in  validateList"
                :key="item.validateRuleGuid"
                :label="item.validName"
                :value="item.validateRuleGuid"
              ></el-option>
            </el-select>
          
          
        </el-row>
        <el-row :gutter="24" class="mt15" v-if="childForm.subjectType == '单行填空题'||childForm.subjectType == '多行填空题'"
          >
          <div class="search-area-div" style="width: 110px; font-size: 14px">
            <span class="fontC-red">*</span>提示语：
          </div>
          <el-input :disabled="subjectReadonly"  v-model.trim="childForm.cueWords" class="fl" style="width: 225px;">
          </el-input>
        </el-row>
        <div
          class="subject-title mt30"
          v-show="
            (childForm.subjectType == '单选题' ||
            childForm.subjectType == '多选题')&& (childForm.subjectItemType=='1'||childForm.subjectItemType=='4')
          "
        >
          <div class="subject-title-name"><span></span>子答案选项配置</div>
          <div class="subject-add-btn"  v-if="childForm.subjectItemType!=='4'" @click="addChildItem">
            <span>+</span>
            添加选项
          </div>
        </div>
        <el-table
          :data="childForm.selectItems"
          style="width: 100%"
          v-show="
            (childForm.subjectType == '单选题' ||
            childForm.subjectType == '多选题')&& (childForm.subjectItemType=='1'||childForm.subjectItemType=='4')
          "
        >
          <template slot="empty">
            <span>暂无选项</span>
          </template>
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="选项名称">
            <template slot-scope="scope">
              <el-select
                  :disabled="subjectReadonly"
                  v-if="childForm.subjectItemType=='4'"
                  class="fl"
                  disabled
                  v-model="scope.row.value"
                  placeholder="请选择"
                >
                  <el-option v-for="item in childTargetOption" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
                <el-input v-else :disabled="subjectReadonly" class="fl" type="input" placeholder="请输入" v-model.trim="scope.row.text" />
            </template>
          </el-table-column>
          <el-table-column v-if="childForm.subjectItemType=='1'" label="排序" width="100">
            <template slot-scope="scope">
              <div class="opreateIcon">
                <i
                  v-if="scope.$index + 1 != childForm.selectItems.length"
                  class="el-icon-sort-down"
                  @click="sortDownField('child', scope.row, scope.$index)"
                ></i>
                <i
                  v-if="scope.$index != 0"
                  class="el-icon-sort-up"
                  @click="sortUpField('child', scope.row, scope.$index)"
                ></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="childForm.subjectItemType=='1'" prop="address" label="操作" width="100">
            <template slot-scope="scope">
              <a class="txt-color"  @click="subjectFieldDel(scope.$index,'child')">删除</a>
            </template>
          </el-table-column>
        </el-table>
        
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" type="info" @click="selectAddSubmit">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 弹窗-设置选择题追加填空规则 -->
    <!-- 弹窗-自动选题 -->
    <el-dialog
      title="自动选题"
      :visible.sync="automaticVisible"
      width="755px"
      :close-on-click-modal="false"
      :append-to-body="true"
      z-index="1000"
    >
      <div class="automatic-box">
        <el-row :gutter="24" class="mb20">
          <el-col :span="18"
            ><div class="search-area-div" style="width: 85px; font-size: 14px; flex-shrink: 0">
              <span class="fontC-red">*</span>题目数量：
            </div>
            <el-input
              style="width: 400px; font-size: 14px"
              placeholder="请输入你要自动生成的题目数量"
              v-model.trim="automaticForm.subjectTotal"
              oninput="value=value.replace(/[^\d]/g,'')"
              @blur="automaticForm.subjectTotal = Number($event.target.value)"
              maxlength="3"
            ></el-input>
          </el-col>
          <el-col :span="6">
            <span class="fontC-4fa1a4" style="line-height: 36px">注：题库现有 {{ page.totalRows }} 道题</span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mb20">
          <el-col :span="18"
            ><div class="search-area-div" style="width: 85px; font-size: 14px; flex-shrink: 0">
              <span class="fontC-red">*</span>题目标签：
            </div>
            <el-cascader
              style="width: 400px"
              v-show="automaticForm.genRule == 3"
              v-model="labelSelectGuid"
              :options="labelList"
              filterable
              @change="handleCascaderChange"
              :show-all-levels="false"
              :props="{
                value: 'guid',
                label: 'labelName',
                children: 'children',
                emitPath: false,
              }"
              clearable
              placeholder="请选择"
            >
            </el-cascader>
            <el-cascader
              style="width: 400px"
              v-show="automaticForm.genRule != 3"
              v-model="ruleList"
              :options="labelList"
              filterable
              @change="handleCascaderChange"
              :show-all-levels="false"
              :props="{
                value: 'guid',
                label: 'labelName',
                children: 'children',
                emitPath: false,
                multiple: true,
              }"
              clearable
              placeholder="请选择"
            >
            </el-cascader>
          </el-col>
          <el-col :span="6" v-if="automaticForm.genRule == 3&&labelTotalRows>0">
            <span class="fontC-4fa1a4" style="line-height: 36px">注：所选标签共 {{ labelTotalRows }} 道题</span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="23">
            <div class="search-area-div" style="width: 85px; font-size: 14px; flex-shrink: 0">
              <span class="fontC-red">*</span>选题规则：
            </div>
            <div class="automatic-distribution">
              <el-radio-group style="line-height: 40px" @change="automaticRadioChange" v-model="automaticForm.genRule">
                <el-radio :label="1">平均分配随机选题</el-radio>
                <el-radio :label="2">按占比分配随机选题</el-radio>
                <el-radio :label="3">按题型选题</el-radio>
              </el-radio-group>
              <div v-show="automaticRadio == 2" class="automatic-wrap-box">
                <div class="distribution-list" v-for="(item, index) in automaticForm.ruleList" :key="index">
                  <div class="distribution-title">{{ item.labelName }}：</div>
                  <div class="distribution-input">
                    <span>占题目总数的</span>
                    <el-input
                      style="width: 100px"
                      placeholder="请输入"
                      v-model.trim="item.percent"
                      oninput="value=value.replace(/[^\d]/g,'')"
                      maxlength="3"
                    ></el-input>
                    <span>%</span>
                  </div>
                </div>
              </div>
              <div v-show="automaticRadio == 3" class="automatic-wrap-box">
                <div class="distribution-list" v-for="(item, index) in subjectTypeList" :key="index">
                  <div class="distribution-title">{{ item.label }}：</div>
                  <div class="distribution-input">
                    <span>随机抽取</span>
                    <el-input
                      style="width: 100px"
                      placeholder="请输入"
                      v-model.trim="item.needNum"
                      oninput="value=value.replace(/[^\d]/g,'')"
                      maxlength="3"
                    ></el-input>
                    <span>道题目</span>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="automaticVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="automaticSubmit">提交</el-button>
      </div>
    </el-dialog>
    <!-- 移动端预览 -->
    <mobile-survey
      :subjectList="pageForm.subjectList"
      :title="pageForm.surveyTitle"
      :desc="pageForm.surveyText=='<p><br></p>'?pageForm.surveyDesc:pageForm.surveyText"
      :videoUrl="pageForm.videoUrl"
      ref="mobileSurvey"
      @pageClose="pageClose"
    ></mobile-survey>
    <!-- 题目关联 -->
    <QuestionConnect
      :subjectList="pageForm.subjectList"
      :branchList="branchList"
      :title="pageForm.surveyTitle"
      :desc="pageForm.surveyText=='<p><br></p>'?pageForm.surveyDesc:pageForm.surveyText"
      ref="questionConnect"
      @pageClose="pageClose"
    ></QuestionConnect>
    <el-dialog width="800px" top="10vh" custom-class="childDialog connectDialog" :visible.sync="addConnectVisible" >
        <div slot="title" style="text-align:left" >
          <span class="dialog-title-active">题目关联</span>
        </div>
        <div style="height: 520px;overflow: auto;">
          <div class="title-box" >
            <span class="title">
              当前题目：{{ currentSubjectIndex+1 }} 、{{ currentSubject.subjectTitle }}
            </span>
            
          </div>
          <div style="text-align: left;">
            <span >
              <el-button type="default" size="small" @click="delCurrent()">仅删除本题关联</el-button>
              <el-button type="default" size="small" @click="delBranch()">删除该条件题目关联</el-button>

            </span>
          </div>

          <el-row :gutter="24" class="mt15 mb15 select-area-div">

            <div class="title-top" @click="batchObj.isTopExpand=!batchObj.isTopExpand">
              <i v-if="batchObj.isTopExpand" class="el-icon-caret-bottom"></i>
              <i v-else class="el-icon-caret-right"></i>
              显示当前题目的条件为：</div>
            <div
             v-show=batchObj.isTopExpand
             class="select-box" 
             v-for="(b,d) in checkedList"
             :style="d+1==checkedList.length?'margin-bottom:10px':''"
             >
              <div class="title-left">
                <div class="title-left-box">
                  <span style="width:60px" v-if="d==0">当 </span>
                  <span v-if="d>1">{{ logicSymbol=='1'?'且':'或' }} </span>
                  <el-select
                    v-if="d==1"
                    style="width:60px;margin-right: 8px;"
                    v-model="logicSymbol"
                    @change="logicChange(b,d)"
                    filterable
                    placeholder=""
                  >
                    <el-option
                      v-for="(item, index) in flgOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <el-select
                  popper-class="select-drop"
                  v-model="b.subjectNo"
                  filterable
                  placeholder="前置题目"
                  @change="xhChange(b.subjectNo,d)"
                >
                  <el-option
                    v-for="(item, index) in qzOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.subjectNo"
                  ></el-option>
                </el-select>
                <span style="padding:0 8px" > 选项为 </span>
                <el-select
                  popper-class="select-drop"
                  v-model="b.subjectOption"
                  multiple
                  :multiple-limit="getXxType(b)=='单选题'?1:0"
                  filterable
                  placeholder="请选择"
                  @change="xxChange"
                >
                  <el-option
                    v-for="(item, index) in getXxOptions(b)"
                    :key="index"
                    :label="item.text"
                    :value="index.toString()"
                  ></el-option>
                </el-select>
              </div>
              <span class="title-right">
                <span v-if="checkedList.length-1==d" @click="addTj(b)">添加条件</span>
                <span v-if="checkedList.length>1" @click="delTj(d)">删除条件</span>
              </span>
            </div>
            
          </el-row>

          <el-row :gutter="24" v-if="checkedList.length&&checkedList[0].subjectNo" class="select-area-div">
            
            <div class="title-top"  @click="batchObj.isExpand=!batchObj.isExpand">
              <i v-if="batchObj.isExpand" class="el-icon-caret-bottom"></i>
              <i v-else class="el-icon-caret-right"></i>
              将条件同时应用到其他题目
            </div>
            <div v-show=batchObj.isExpand style="width: 100%;">
              <div class="select-box mb10">
                <span class="title-left">
                  <div class="">
                    <!-- <span class="title-right">
                      <span>批量选择</span>
                    </span> -->
                    <span style="margin-left: 12px;"> 快捷选择从 </span>
                  </div>
                  <el-select
                    popper-class="select-drop"
                    v-model="batchObj.start"
                    filterable
                    placeholder="请选择"
                    @change="batchChange"
                  >
                    <el-option
                      v-for="(item, index) in bhList"
                      :key="index"
                      :label="item.label"
                      :value="item.subjectNo"
                    ></el-option>
                  </el-select>
                  <span style="padding:0 8px"> 到 </span>
                  <el-select
                    popper-class="select-drop"
                    v-model="batchObj.end"
                    filterable
                    placeholder="请选择"
                    @change="batchChange"
                  >
                    <el-option
                      v-for="(item, index) in bhList"
                      :key="index"
                      :label="item.label"
                      :value="item.subjectNo"
                    ></el-option>
                  </el-select>
                </span>
                <span class="title-right">
                  <span @click="clearItem()">全部清空</span>
                </span>
              </div>
              <el-checkbox-group
              class="subject-group" v-model="batchObj.subjectNos" style="line-height: 28px;max-height: 300px;overflow-y: scroll;">
                <el-checkbox
                  class="subject-radio"
                  v-for="(o, d) in bhList"
                  :key="d"
                  :disabled="o.disabled"
                  :label="o.subjectNo"
                >
                <span v-if="!o.disabled">{{ o.label }}</span>

                <el-tooltip v-if="o.disabled" placement="top-start" effect="light">
                  <div slot="content">
                    <p>条件已应用，如需修改，请选择编辑此题进行修改</p>
                  </div>
                  <span class="showTooltip">{{ o.label }}</span>
                </el-tooltip>
                
              </el-checkbox>
              </el-checkbox-group>
            </div>

            

          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" @click="dialogCancel">取消</el-button>
          <el-button size="medium" type="info" @click="dialogSure">保存</el-button>
        </span>
    </el-dialog>
    <!-- 知情同意书查看 -->
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcLists" />
    <RejectQuestionnaireReviewDialog
      ref="RejectQuestionnaireReviewDialogRef"
      @submit="handleRejectSubmit"
    ></RejectQuestionnaireReviewDialog>
    <PassQuestionnaireReviewDialog
      ref="PassQuestionnaireReviewDialogRef"
      @submit="handlePassSubmit"
    ></PassQuestionnaireReviewDialog>
  </div>
</template>
<script>
import { route, ENV } from '@/api/apiRoute';
import { getSurveyChangeNew, getSurveyDetail } from '@/api/msSalesPerformService';
import store from '@/store';
import workFlowCommon from '@/uilt/workFlowCommon';
import { bpmnroute } from '@/api/apiRoute';
import mobileSurvey from '@/components/mobileSurvey.vue';
import Editor from './components/Editor.vue';
import SurveyVideoUpload from './components/SurveyVideoUpload.vue';
import QuestionConnect from './questionConnect.vue';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { cloneDeep, isEqual } from 'lodash';
import { SelectItemsValue, SelectQuestionType } from './enum'
import PassQuestionnaireReviewDialog from "./components/PassQuestionnaireReviewDialog.vue";
import RejectQuestionnaireReviewDialog from "./components/RejectQuestionnaireReviewDialog.vue";
export default {
  components: {
    PassQuestionnaireReviewDialog,
    RejectQuestionnaireReviewDialog,
    mobileSurvey,
    ElImageViewer,
    QuestionConnect,
    Editor,
    SurveyVideoUpload
  },
  data() {
    return {
      SelectQuestionType,
      SelectItemsValue,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      srcLists:[],
      contentMainHeight:window.innerHeight - 100,
      isExpand1:true,
      isExpand2:true,
      isExpand3:true,
      isExpand4:false,
      //添加关联
      addConnectVisible:false,//题目关联弹窗
      currentSubject:{},//当前题目
      qzOptions:[],//前置条件的选项
      // xxOptions:[],//选择的题目的选项
      checkedList:[],//当前题目的条件
      bhList:[],//应用的题目选项
      branchListIndex:-1,//当前条件的下标
      delXxObj:{},
      batchObj :{//条件应用的题目
        isTopExpand:true,
        isExpand:false,
        start:'',//前
        end:'',//后
        subjectNos:[],//选择的题目
      },//批量选择的题目
      branchList:[
        // {
        //   logicSymbol:null,//如果flg为1，则表示tjList里面的条件为且的关系，2为或的关系 
        //   rule:[],//选择的条件
        //   subjectNos:[],//选择的题目
        // },
      ],
      flgOptions:[
        {label:'且',value:'1'},
        {label:'或',value:'2'},
      ],
      logicSymbol:'1',//且/或
      // tjList:[
      // {
      //   guid:'',//每个条件自己的标识
      //   checkedNo:0,//条件的编号，用于标识
      //   flg:true,//如果flg为true，则表示tjList里面的条件为且的关系，false为或的关系
      //   checkedList:[//选中的条件条件为第一题选A，第二题选B，第三题选A，则显示6,7,8
      //     {no:'1',text:'A'},
      //     {no:'2',text:'B'},
      //     {no:'3',text:'A'},
      //   ],
      //   tmList:[6,7,8],//应用的题目
      // },
      // ],//所有关联的列表
      //添加题目
      // configData:[],
      activeName:'first',
      oldSubjectType:'',
      oldChildType:'',
      subjectType: 1, //选题类型
      subjectTitle: '添加题目',
      subjectVisible: false,
      selectAddVisible:false,
      targetOption: [], //调研对象/字典下拉
      childTargetOption: [], //字典下拉
      subjectTypeList: [
        {
          label: '单选题',
          value: '单选题',
          needNum:0
        },
        {
          label: '多选题',
          value: '多选题',
          needNum:0
        },
        {
          label: '单行填空题',
          value: '单行填空题',
          needNum:0
        },
        {
          label: '多行填空题',
          value: '多行填空题',
          needNum:0
        },
        {
          label: '选择区域',
          value: '选择区域',
          needNum:0
        },
        {
          label: '调研对象',
          value: '调研对象',
          needNum:0
        },
        {
          label: '客户名称',
          value: '客户名称',
          needNum:0
        },
        {
          label: '年月',
          value: '年月',
          needNum:0
        },
        {
          label: '年月日',
          value: '年月日',
          needNum:0
        },
        {
          label: '时间',
          value: '时间',
          needNum:0
        },
        {
          label: '填写日期',
          value: '填写日期',
          needNum:0
        },
        {
          label: '定位签到',
          value: '定位签到',
          needNum:0
        },
        {
          label: '上传照片(拍照带水印)',
          value: '上传照片(拍照带水印)',
          needNum:0
        },
        {
          label: '上传照片(拍照不带水印)',
          value: '上传照片(拍照不带水印)',
          needNum:0
        },
        {
          label: '选择医疗机构',
          value: '选择医疗机构',
          needNum:0
        },
        {
          label: '选择等级医院',
          value: '选择等级医院',
          needNum:0
        },
        {
          label: '选择基层医疗',
          value: '选择基层医疗',
          needNum:0
        },
        {
          label: '选择药店',
          value: '选择药店',
          needNum:0
        },
        {
          label: '选择商业公司',
          value: '选择商业公司',
          needNum:0
        },
      ],
      subjectTypeSharing: [
        {
          label: '单选题',
          value: '单选题',
        },
        {
          label: '多选题',
          value: '多选题',
        },
        {
          label: '单行填空题',
          value: '单行填空题',
        },
        {
          label: '多行填空题',
          value: '多行填空题',
        },
        {
          label: '选择区域',
          value: '选择区域',
        },
        // {
        //   label: '调研对象',
        //   value: '调研对象',
        //   needNum:0
        // },
        // {
        //   label: '客户名称',
        //   value: '客户名称',
        //   needNum:0
        // },
        {
          label: '年月',
          value: '年月',
        },
        {
          label: '年月日',
          value: '年月日',
        },
        {
          label: '时间',
          value: '时间',
        },
        {
          label: '填写日期',
          value: '填写日期',
        },
        // {
        //   label: '定位签到',
        //   value: '定位签到',
        // },
        {
          label: '上传照片(拍照带水印)',
          value: '上传照片(拍照带水印)',
        },
        {
          label: '上传照片(拍照不带水印)',
          value: '上传照片(拍照不带水印)',
        },
        // {
        //   label: '选择医疗机构',
        //   value: '选择医疗机构',
        //   needNum:0
        // },
        // {
        //   label: '选择等级医院',
        //   value: '选择等级医院',
        //   needNum:0
        // },
        // {
        //   label: '选择基层医疗',
        //   value: '选择基层医疗',
        //   needNum:0
        // },
        // {
        //   label: '选择药店',
        //   value: '选择药店',
        //   needNum:0
        // },
        // {
        //   label: '选择商业公司',
        //   value: '选择商业公司',
        //   needNum:0
        // },
      ],
      childTypeList: [
        {
          label: '单选题',
          value: '单选题',
          needNum:0
        },
        {
          label: '多选题',
          value: '多选题',
          needNum:0
        },
        {
          label: '单行填空题',
          value: '单行填空题',
          needNum:0
        },
        {
          label: '多行填空题',
          value: '多行填空题',
          needNum:0
        },
        {
          label: '选择区域',
          value: '选择区域',
          needNum:0
        },
        {
          label: '年月',
          value: '年月',
          needNum:0
        },
        {
          label: '年月日',
          value: '年月日',
          needNum:0
        },
        {
          label: '时间',
          value: '时间',
          needNum:0
        },
        {
          label: '定位签到',
          value: '定位签到',
          needNum:0
        },
        // {
        //   label: '上传照片(拍照带水印)',
        //   value: '上传照片(拍照带水印)',
        //   needNum:0
        // },
        // {
        //   label: '上传照片(拍照不带水印)',
        //   value: '上传照片(拍照不带水印)',
        //   needNum:0
        // },
        {
          label: '选择医疗机构',
          value: '选择医疗机构',
          needNum:0
        },
        {
          label: '选择等级医院',
          value: '选择等级医院',
          needNum:0
        },
        {
          label: '选择基层医疗',
          value: '选择基层医疗',
          needNum:0
        },
        {
          label: '选择药店',
          value: '选择药店',
          needNum:0
        },
        {
          label: '选择商业公司',
          value: '选择商业公司',
          needNum:0
        },
      ],
      childTypeSharing: [
        {
          label: '单选题',
          value: '单选题',
          needNum:0
        },
        {
          label: '多选题',
          value: '多选题',
          needNum:0
        },
        {
          label: '单行填空题',
          value: '单行填空题',
          needNum:0
        },
        {
          label: '多行填空题',
          value: '多行填空题',
          needNum:0
        },
        {
          label: '选择区域',
          value: '选择区域',
          needNum:0
        },
        {
          label: '年月',
          value: '年月',
          needNum:0
        },
        {
          label: '年月日',
          value: '年月日',
          needNum:0
        },
        {
          label: '时间',
          value: '时间',
          needNum:0
        },
        // {
        //   label: '定位签到',
        //   value: '定位签到',
        //   needNum:0
        // },
        // {
        //   label: '上传照片(拍照带水印)',
        //   value: '上传照片(拍照带水印)',
        //   needNum:0
        // },
        // {
        //   label: '上传照片(拍照不带水印)',
        //   value: '上传照片(拍照不带水印)',
        //   needNum:0
        // },
        // {
        //   label: '选择医疗机构',
        //   value: '选择医疗机构',
        //   needNum:0
        // },
        // {
        //   label: '选择等级医院',
        //   value: '选择等级医院',
        //   needNum:0
        // },
        // {
        //   label: '选择基层医疗',
        //   value: '选择基层医疗',
        //   needNum:0
        // },
        // {
        //   label: '选择药店',
        //   value: '选择药店',
        //   needNum:0
        // },
        // {
        //   label: '选择商业公司',
        //   value: '选择商业公司',
        //   needNum:0
        // },
      ],
      subjectItemTypeSharing:[
        {
          text: '自定义选项',
          value: '1',
        },
        {
          text: '选择平台字典',
          value: '4',
        },
      ],
      subjectForm: {
        subjectTitle: '',
        subjectType: '',
        orderNum: '',
        isRequired: 'Y',
        inputText: '',//一般题型的答案
        otherInput: null,//移动端客户名称的guid
        valueSelect: [],//多选题的答案选项
        selectItems: [],//选项表格的数据
        subjectLabelGuid: null,//题目标签
        isValidateUnique: 'N',//是否唯一校验
        validateGuid:"", //验证方式
        subjectItemType:'',//题型分类
        dictGuid:'',//字典名称
        dictName:'',//字典名称
        interactType:'',//交互类型
      },
      childForm: {
        subjectType: '',
        inputText: '',
        valueSelect: [],
        selectItems: [],
        isValidateUnique: 'N',//校验唯一性
        validateGuid:"", //验证方式
        subjectItemType:'',//题型分类
        dictGuid:'',//字典名称
        dictName:'',//字典名称
        interactType:'',//交互类型
        cueWords:'',//提示语
        index:null,
      },
      currentSubjectIndex: -1, //修改题目当前index
      subjectEdit: false,
      subjectView: false,
      options: [],
      //页面提交
      pageForm: {
        guid: null,
        isPlatformTemplate:'N',
        surveyLabelList: [],
        surveyTitle: null,
        surveyDesc: null,
        surveyText:null,
        videoUrl: null,
        tenantGuid: null,
        tenantName: null,
        organisationGuid: null,
        isSharing: '0',
        surveyState: 'Y',
        isDraft: 'N',
        isOpenProtocol: 'N',
        protocolKeyWord: '',
        subjectList: [],
        serviceTenantGuid: null,
        qualityCheckConfig: {
          // inputDateCheckEnabled: true,
          quantityCheckEnabled: true,
          // appInputMonthMaxCheckEnabled: true,
          quantityCheckLowLimit: 2,
          quantityCheckUpLimit: 7,
          // appInputMonthMax: 50,
        },
        
        notSelfSubmit:false,
        surveyExecuteRules:[
          // 默认配置
          {
            personRule:'1',
            dateRule:'3',
            dayNum:'1',
            customerRule:'',
            maxValue:'50',
            ruleDesc:'当前问卷同一人员1天内最多提交50份',
            tips:'您提交的问卷已达单日上限 50 份，请勿提交'
          }
        ],//执行规则
        surveyRuleConfig:{
          signLocation:{//签到规则
            maxRadius:'2000',
            allowOutside:'Y'
          },
          visitRight:{//权限规则
            isFastAdd:'Y',
            isSimpleFastAdd: 'N', // 完整资料建档、简易建档 ，Y为简易建档
            isEsQuery:'N',
            isProductEs:'Y',
            isDeptEs:'N',
            visitRadioList:[]
          },
        },//规则配置
      },
      pageShow: true,
      checked: true,
      value: [],
      fullscreenLoading: false,
      height: window.innerHeight - 260,
      right: 'right',
      sendTenantList: [],
      surveyLabelOptions: [],
      // tenantList: [],
      tenantName: '',
      tenantGuid: '',
      departmentVisible: false, //部门弹框
      area: [],
      departmentList: [],
      departmentData: '',
      organisationNameList: '',
      areaData: [],
      delList: [],
      filterText: '',
      defaultProps: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
        disabled: this.disabledTreeNode,
      },
      visible: false,
      currentIndex: '',
      isEdit: false,
      //批量选题
      surveyTitle: '',
      surveyList: [],
      validateList:[],
      surveyGuid: null,
      tableLoading: false,
      multipleSelection: [],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: null,
        surveyTenantGuid: null,
        labelGuid: null,
        subjectTitle: null,
        subjectType: null,
      },
      //自动选题
      automaticVisible: false,
      automaticRadio: 1,
      automaticForm: {
        tenantGuid: null,
        subjectTotal: null,
        genRule: 1,
        ruleList: [],
        excludeSubjectType: [],
      },
      ruleList: [],
      labelSelectGuid:'',
      labelTotalRows:0,
      //获取标签列表
      labelList: [],
      labelAddList: [],
      labelName: '',
      showViewer: false, // 显示查看器
      isEdit:false,
      isDetail:false, // 详情模式
      isResubmit: false, // 重新提交模式
      isCopy: false,// 复制
      dataFrom:null,
      isCurrent:false,
      originalSubjectList: [],
      url: require('../../assets/images/agree_pic.png'),
      visitRadioList:[],
      // visitRadioListKey:[],
      dictList:[],
      connectVisible:false,
      // 流程图相关
      iframeSh: false,
      iframeSrc: '',
      processNodes: null, // 流程图数据
      rejectRecordInfo: null, // 拒绝记录
    };
  },
  async created() {
    if (this.$route.query.type == 0) {
      this.subTitle = '复制' + localStorage.threeLevels;
      this.dataFrom=11
      this.isCopy = true
    } else if (this.$route.query.type == 1) {
      this.isEdit=true
      this.dataFrom=1
      this.subTitle = '编辑' + localStorage.threeLevels;
    } else if (this.$route.query.type == 2) {
      this.isDetail = true
      this.dataFrom = 2
      this.subTitle = localStorage.threeLevels + '详情';
    } else if (this.$route.query.type == 3) {
      this.isEdit = true
      this.isResubmit = true
      this.dataFrom = 0
      this.subTitle = '重新提交' + localStorage.threeLevels;
    } else {
      this.dataFrom=0
      this.subTitle = '新增' + localStorage.threeLevels;
    }
    if (this.$route.query.guid) {
      this.pageForm.guid = this.$route.query.guid;
      if(this.$route.query.type==1 || this.$route.query.type == 3){//编辑 或 重新提交
        this.getCurrentStatus(this.$route.query.guid)
      }
      
    }
    this.getHeartDictList();
    // this.getTenantList();
    this.getCustomerList()
    // this.getSendTenantList();放在getCustomerList后面
    this.getSurveyList();
    // this.getValidateList();//后面要根据题目类型动态获取
    this.getSubject();
    this.getLabelList();
    this.getDictList()
    // this.getTargetList();//调研对象的题目选项
    if (this.$route.query.guid) {
      await this.getDetail();
      await this.getProcessNodes()
    }
    this.getApprovalList()
  },
  computed: {
    /**
     * 新增 编辑 复制
     * @returns {boolean}
     */
    isAdd_Update_Copy(){
      return [0, 1, 11].includes(this.dataFrom)
    },
    subjectReadonly() {
      return this.isDetail || this.subjectView;
    },
  },
  filters: {
    sjFilters(value) {
      let str = '';
      let lookUp = {
        '1': '个月内',
        '2': '个月内',
        '3': '天内',
      };
      if(value){
        str=lookUp[value]
      }
      return str
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    'pageForm.isPlatformTemplate':{
      immediate: true,
      handler(newVal, oldVal) {
        if(newVal=='Y'){
          this.pageForm.tenantGuid= null
          this.pageForm.tenantName= null
          this.pageForm.organisationGuid= null
          this.pageForm.surveyRuleConfig.visitRight.isEsQuery='Y'
          this.pageForm.surveyRuleConfig.visitRight.isDeptEs='Y'
        }
        
      }
    },
    'selectAddVisible':{
      immediate: true,
      handler(newVal, oldVal) {
        if(newVal==true){
          this.subjectVisible= false
          
        }else if(oldVal==true&&newVal==false){
          this.subjectVisible= true
        }
        
      }
    },
  },
  methods: {
    async toRevoke() {
      let confirm = false;
      try {
        // 等待用户确认
        confirm = await this.$confirm(messageConfig.FLOW_IS_CANCEL, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch (error) {
        // 用户点击取消
        this.$message({
          type: "info",
          message: "已取消操作！",
        });
      }
      console.log("confirm", confirm);
      if (!confirm) {
        return;
      }
      // 用户确认后执行撤销逻辑
      const { approveVO } = this.pageForm;
      const query = {
        guid: approveVO.approveGuid,
        flowType: approveVO.flowType,
        approveStaffGuid: approveVO.staffGuid,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`,
        query
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.$message.success(messageConfig.FLOW_CANCEL);
      this.$router.go(-1);

    },
    // 获取流程节点信息
    async getProcessNodes() {
      const { approveVO } = this.pageForm;
      if (!approveVO || !approveVO.camundaDeploymentId || !approveVO.camundaInstanceId) {
        return;
      }
      const params = {
        deploymentId: approveVO.camundaDeploymentId,
        processInstanceId: approveVO.camundaInstanceId,
      };
      const { data } = await this.api.postJson(
        `/camunda-server/process-definition/get-process-nodes`,
        params
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.processNodes = data.data;
      // 从流程节点中提取驳回信息 详情页面才展示
      if (this.isDetail) {
        this.extractRejectInfo();
      }
    },
    /**
     * 从流程节点数据中提取驳回信息
     */
    extractRejectInfo() {
      // 遍历所有流程节点
      for (const node of this.processNodes) {
        // 检查是否有审批人员信息
        if (node.staffVOS?.length > 0) {
          // 查找驳回状态的审批记录
          const rejectRecord = node.staffVOS.find(staff => staff.approvalState === 'R');
          if(!rejectRecord){
            continue
          }
          this.rejectRecordInfo = rejectRecord;
        }
      }
    },
    /**
     * 获取流程
     */
    getApprovalList() {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let { approveVO } = this.pageForm;
      if (this.$route.query.guid && approveVO && approveVO.camundaInstanceId && approveVO.camundaDeploymentId && !this.isCopy && !this.isResubmit) {
        this.iframeSrc =
          bpmnroute +
          '/iframeBpmn?processInstanceId=' +
          approveVO.camundaInstanceId +
          '&camundaDeploymentId=' +
          approveVO.camundaDeploymentId +
          '&token=' +
          localStorage.token;
        this.iframeSh = true;
        this.$forceUpdate()
        return;
      }
      // 新增问卷流程=00042，修改问卷流程=00043
      let req = {
        tenantGuid: localStorage.guid,
        flowType: '00042',
        staffGuid: userInfo.staffGuid,
      };
      // 有审批流记录按记录；编辑模式下（含历史数据编辑）按修改流程预览，草稿编辑除外
      if(approveVO?.flowType == '00043' || (this.isEdit && !this.isResubmit && !this.isCopy && this.pageForm.isDraft != 'Y')){
        req.flowType = '00043'
      }
      if (this.isCopy) {
        req.flowType = '00042'
      }
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              
              self.iframeSrc =
                bpmnroute + '/iframeBpmn?camundaDeploymentId=' + res.data.data + '&token=' + localStorage.token;
              self.iframeSh = true;
              this.$forceUpdate()
            } else {
              self.$message.error('未获取到流程信息');
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    rejectDialogClick(){
      this.$refs.RejectQuestionnaireReviewDialogRef.open()
    },
    async handleRejectSubmit(val){
      const userinfo = JSON.parse(localStorage.userInfo);
      const query = {
        guid: this.pageForm.approveVO.approveGuid,
        flowType: this.pageForm.approveVO.flowType,
        approveSuggest: val,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`,
        query
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.$message.success(messageConfig.FLOW_REJECT);
      this.$router.go(-1)
      this.$refs.RejectQuestionnaireReviewDialogRef.close()
    },
    passDialogClick(){
      this.$refs.PassQuestionnaireReviewDialogRef.open()
    },
    async handlePassSubmit(val){
      const userinfo = JSON.parse(localStorage.userInfo);
      const query = {
        guid: this.pageForm.approveVO.approveGuid,
        flowType: this.pageForm.approveVO.flowType,
        approveSuggest: val,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`,
        query
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.$router.go(-1)
      this.$refs.PassQuestionnaireReviewDialogRef.close()
    },
    /**
     * 获取操作按钮显隐
     * @param {*} btnType
     */
    getBtnState(btnType) {
      const { approveVO } = this.pageForm;
      if (approveVO) {
        let userinfo = JSON.parse(localStorage.userInfo);
        return workFlowCommon.getListBtnState(
          btnType,
          approveVO.approveState,
          approveVO.staffGuid,
          approveVO.approveStaffGuids,
          userinfo.staffGuid,
          approveVO.approveState,
        );
      }
    },
    changeData(data){
      this.pageForm.surveyText = data
    },
    /** 参考图片 上传相关 开始*/
    handleBillRemove(file) {
      let self = this;
      self.subjectForm.pictUrl.forEach(function (j, ind) {
        if (j.path == file.path) {
          self.subjectForm.pictUrl.splice(ind, 1);
        }
      });
    },
    uploadBillImage(file) {
      let self = this;
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            var path = decodeURIComponent(res.data.data);
            var str = file.file.name;
            let lastDotIndex = str.lastIndexOf('.');
            if (lastDotIndex!== -1) {
                str = str.substring(0, lastDotIndex);
            }
            let item = {
              fileName: str,
              path: res.data.data,
            };
            self.subjectForm.pictUrl.push(item);
            this.$nextTick(()=>{
              self.$forceUpdate()
            })
            self.$message.success('上传成功');
          } else {
            // self.pictContentList.splice(0, 1);
            self.subjectForm.pictUrl=JSON.parse(JSON.stringify(self.subjectForm.pictUrl))
            this.$nextTick(()=>{
              self.$forceUpdate()
            })
           
            self.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          self.$message.error(err);
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 5 个文件`);
    },
   
    handlePictureCardPreview(file) {
      this.srcLists = this.subjectForm.pictUrl.map(e=> e.path);
      let index = this.srcLists.indexOf(file.path);
      if (index !== -1){
        this.srcLists=[file.path,...this.srcLists.slice(index + 1),...this.srcLists.slice(0, index)]
      }
      //设置 图片查看器 进行显示
      console.log('this.srcLists',this.srcLists,file);
      
      this.$forceUpdate();
      this.showViewer = true;
    },
    getPadding(item,items, index1){
      let flg=false
      let last=index1+1==item.selectItems.length
      let isAdd=items.isAdd
      let flg1=false
      let flg2=false
      if(isAdd){
        flg1=items.subjectItem.subjectType=='单选题'&&(items.subjectItem.subjectItemType=='1'||items.subjectItem.subjectItemType=='4')&&items.subjectItem.interactType=='1'
        flg2=items.subjectItem.subjectType == '多选题'&&(items.subjectItem.subjectItemType=='1'||items.subjectItem.subjectItemType=='4')&&items.subjectItem.interactType=='1'
      }
      if(last){
        if(isAdd&&(flg1||flg2)||!isAdd){
          flg=false
        }else{
          flg=true
        }
      }else{
        flg=false
      }
      return flg
    },

    addTj(row){//添加条件
      if(!row.subjectNo||!row.subjectOption||row.subjectOption.length<1){
        this.$message.warning('请填写完整后再新增');
        return
      }else{
        let obj={
          subjectNo:'',//前置题目序号，
          subjectOption:[],//选项
          // flg:'',//或/且
          // isExpand:true,//分支列表里的
        }
        this.checkedList.push(obj)
      }
    },
    delTj(idx){//删除条件
      this.$confirm('确定删除此条件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.checkedList.splice(idx, 1);
        if(this.checkedList.length<2){
          this.logicSymbol='1'
        }
        this.xxChange()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      
    },
    delCurrent(){//删除本题关联
      this.$confirm('确定删除本题的关联逻辑吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(this.branchListIndex>-1){
          let num=this.currentSubject.subjectNo//题目的编号
          let list=this.branchList[this.branchListIndex].subjectNos
          if (list.filter(obj=>obj!=num).length === 0) {
              // 如果为空，删除当前项
              this.branchList.splice(this.branchListIndex, 1);
          }else{
            this.branchList[this.branchListIndex].subjectNos=list.filter(obj=>obj!=num)
          }
        }
        
        this.addConnectVisible=false
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      
    },
    delBranch(){//删除该条件题目关联
      this.$confirm('确定删除该条件应用的所有题目关联吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(this.branchListIndex>-1){
          this.branchList.splice(this.branchListIndex, 1);
        }
        this.addConnectVisible=false
        
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      
    },
    clearItem(){//清空题目
      this.batchObj.start=''
      this.batchObj.end=''
      this.batchChange()
    },
    batchChange(){
      let obj=this.batchObj
      let that=this
      let startIndex = -1;
      let endIndex = -1;
      // this.batchObj.subjectNos=[]
      let arr=this.bhList.filter(i=>i.disabled)||[]
      this.batchObj.subjectNos=arr.length>0?arr.map(i=>i.subjectNo):[]
      if(!obj.start||!obj.end)return
      // 找到 start 和 end 对应的索引
      for (let i = 0; i < this.bhList.length; i++) {
        let start=Number(obj.start)>Number(obj.end)?obj.end:obj.start
        let end=Number(obj.start)>Number(obj.end)?obj.start:obj.end
        
          if (this.bhList[i].subjectNo === start) {
              startIndex = i;
          }
          if (this.bhList[i].subjectNo === end) {
              endIndex = i;
          }
      }

      // 如果找到了有效的 start 和 end 索引
      if (startIndex!== -1 && endIndex!== -1) {
          for (let i = startIndex; i <= endIndex; i++) {
            that.batchObj.subjectNos.push(that.bhList[i].subjectNo);
            
          }
      }
      that.batchObj.subjectNos = [...new Set(that.batchObj.subjectNos)]
      
    },
    logicChange(b,d){
      if(this.logicSymbol=='1'){
        this.checkedList=this.checkedList.slice(0, 1)
        let obj={
          subjectNo:'',//前置题目序号，
          subjectOption:[],//选项
        }
        this.checkedList.push(obj)
      }else{
        
        // this.getOption(this.currentSubjectIndex)
        // this.xhChange(b.subjectNo,d)
      }
      this.xxChange()
    },
    xhChange(val,d){//选题改变
      
      if(!val)return
      var mapArr = this.checkedList.map(item => item.subjectNo);
      var setArr = new Set(mapArr);//去重
      if (this.logicSymbol=='1' && setArr.size< mapArr.length ) {
        this.$message.error('关联题目不能重复，请重新选择');
        this.checkedList[d].subjectNo=''
      }
      
      let obj=[]
      obj=this.qzOptions.filter(item => item.subjectNo === val)
      this.checkedList[d].subjectOption=[]
    },
    getXxType(b){
      let obj=this.pageForm.subjectList.filter(item => item.subjectNo === b.subjectNo)
      let type=obj.length>0?obj[0].subjectType:''
      return type
    },
    getXxOptions(b){
      let obj=this.pageForm.subjectList.filter(item => item.subjectNo === b.subjectNo)
      let arr=obj.length>0?obj[0].selectItems:[]
      
      return arr
    },
    xxChange(){//选项改变的时候去遍历 branchList有相同的就是编辑，没相同的就是新增

      let index=this.findMatchingIndex()
      this.branchListIndex=index
      this.batchObj.start=''
      this.batchObj.end=''
      if(index>-1){//有相同的条件,把那个条件的应用题目带出来
        
        let foundItem = index!== -1? cloneDeep(this.branchList[index]) : null;
        let subjectNos=null
        if(foundItem){//编辑
          subjectNos=foundItem.subjectNos
          this.batchObj.subjectNos=subjectNos.filter(item=>item!==this.currentSubject.subjectNo)
          
        }
        this.getOption(-1,subjectNos)
      }else{
        this.batchObj.subjectNos=[]
        this.getOption(this.currentSubjectIndex)
      }
    },
    // 判断改排序会不会影响条件逻辑
    affectBranch(r,idx,newOrderNum){
      // idx为当前序号下移看下面一题
      
      let row=this.pageForm.subjectList[idx]
      let num=row.subjectNo//题目的编号，通过编号寻找是否有规则(是否被应用)
      let index = this.branchList.findIndex(item => item.subjectNos.includes(num));
      let foundItem = index!== -1? this.branchList[index] : null;     
      let allGreater = false;
      if(foundItem){//有规则
        for (const ruleItem of foundItem.rule) {
          const subjectNo = Number(ruleItem.subjectNo);
          // 在 arr 中查找对应的 orderNum
          const match = this.pageForm.subjectList.find(item => Number(item.subjectNo) === subjectNo);

          if (match) {
              const orderNum = Number(match.orderNum);
              // 判断 num 是否大于 orderNum
              if (newOrderNum <= orderNum) {
                  allGreater = true;
                  break;
              }
          }
        }
      }      
      return allGreater
    },
    
    isUsed(row){// 是否被应用subjectNos
      let num=row.subjectNo//题目的编号，通过编号寻找是否有规则(是否被应用)
      let index = this.branchList.findIndex(item => item.subjectNos.includes(num));
      return index>-1
    },
    isRely(row){//当前题是否被作为条件rule
      let result =false
      let num=row.subjectNo//题目的编号，通过编号寻找是否有规则(是否被应用)
      result = this.branchList.some(item => {//是否被依赖
          return item.rule.some(ruleItem => {
              return Number(ruleItem.subjectNo) === Number(num);
          });
      });
      return result
    },
    changeXxSort(row,d,dp){
      let num=row.subjectNo
      // 筛选出 this.branchList 中 rule 数组里 subjectNo 等于 num 的项
      let matchingItems = this.branchList.flatMap(item => {
          return item.rule.filter(ruleItem => {
              return Number(ruleItem.subjectNo) === Number(num);
          });
      });
      matchingItems.forEach(item => {
          item.subjectOption = item.subjectOption.map(option => {
            if (Number(option) === d) {
                return String(dp);
            } else if (Number(option) === dp) {
                return String(d);
            }
            return option;
          });
      });
    },
    delXx(row,d){
      let num=row.subjectNo
      // 筛选出 this.branchList 中 rule 数组里 subjectNo 等于 num 的项
      let matchingItems = this.branchList.flatMap(item => {
          return item.rule.filter(ruleItem => {
              return Number(ruleItem.subjectNo) === Number(num);
          });
      });
       // 检查是否有 subjectOption 等于 d 的项
      let hasMatchingOption = matchingItems.some(item => item.subjectOption.some(option => Number(option) === d))
      
      return hasMatchingOption
    },
    delXxSure(num,d){
      for (let k = 0; k < d.length; k++) {
        let currentD = d[k];
        // 遍历 this_branchList
        for (let i = this.branchList.length - 1; i >= 0; i--) {
            let item = this.branchList[i];
            let newRule = [];

            // 遍历 rule 数组
            for (let j = 0; j < item.rule.length; j++) {
                let ruleItem = item.rule[j];
                if (Number(ruleItem.subjectNo) === Number(num)) {
                    let newSubjectOption = [];
                    for (let k = 0; k < ruleItem.subjectOption.length; k++) {
                        let option = ruleItem.subjectOption[k];
                        if (Number(option) === currentD) {
                            // 如果 subjectOption 中的元素等于当前 d 的值，跳过该元素
                            continue;
                        } else if (Number(option) > currentD) {
                            // 如果 subjectOption 中的元素大于当前 d 的值，将该元素的值减 1
                            newSubjectOption.push(String(Number(option) - 1));
                        } else {
                            newSubjectOption.push(option);
                        }
                    }
                    ruleItem.subjectOption = newSubjectOption;
                    newRule.push(ruleItem);
                } else {
                    newRule.push(ruleItem);
                }
            }

            // 更新 rule 数组
            item.rule = newRule;

            // 如果 rule 长度为 0，去掉 this_branchList 中的这一项
            if (item.rule.length === 0) {
                this.branchList.splice(i, 1);
            }
        }
      }      
    },
    getTips(row){
      let num=row.subjectNo//题目的编号，通过编号寻找是否有规则
      let index = this.branchList.findIndex(item => item.subjectNos.includes(num));
      let foundItem = index!== -1? this.branchList[index] : null;
     
      if(!foundItem)return false
      //点保存的时候把条件说明存下来 getXxOptions
      const connector =  foundItem.logicSymbol === '1'? ', 且' : ', 或者';
      // 用于存储每个条件字符串的数组
      const conditions = [];
      // 遍历 rule 生成每个条件字符串
      foundItem.rule.forEach(item => {
        let arr=this.getXxOptions(item)
        let optionTexts = item.subjectOption.map(optionIndex => {
            let optionObj = arr[parseInt(optionIndex)];
            return optionObj? optionObj.text : '';
        }).filter(text => text!== '');

        let optionTextStr = optionTexts.join(' 且 ');
        let idx=this.pageForm.subjectList.findIndex(i=>i.subjectNo==item.subjectNo)
       
        
        conditions.push(`当【题目${idx+1}】选择【${optionTextStr}】时`);//
      });
      // 将所有条件字符串用连接词连接起来
      const conditionStr = conditions.join(` ${connector}`);
      // 生成最终字符串
      const str = `说明：${conditionStr}，此题才显示`;
      return str
    },

    findMatchingIndex() {
      let arr=this.branchList
      let list=this.checkedList
      let flg=this.logicSymbol
      for (let i = 0; i < arr.length; i++) {
          const currentItem = arr[i];
          // 检查 logicSymbol 是否相同
          if (currentItem.logicSymbol === flg) {
              const rule = currentItem.rule;
              // 检查 rule 数组长度是否相同
              if (rule.length === list.length) {
                  let isMatch = true;
                  // 遍历 rule 数组中的每个对象
                  for (let j = 0; j < rule.length; j++) {
                      const ruleObj = rule[j];
                      const listObj = list[j];
                      // 遍历对象的每个属性进行比较
                      for (const key in ruleObj) {
                          if (ruleObj[key]!== listObj[key]) {
                              isMatch = false;
                              break;
                          }
                      }
                      if (!isMatch) {
                          break;
                      }
                  }
                  if (isMatch) {
                      return i;
                  }
              }
          }
      }
      return -1;
    },

    // 自定义函数，用于比较两个数组是否完全相同
    isArrayEqual(arr1, arr2) {
      if (arr1.length!== arr2.length) {
          return false;
      }
      for (let i = 0; i < arr1.length; i++) {
          const obj1 = arr1[i];
          const obj2 = arr2[i];
          const keys1 = Object.keys(obj1);
          const keys2 = Object.keys(obj2);
          if (keys1.length!== keys2.length) {
              return false;
          }
          for (let key of keys1) {
              if (obj1[key]!== obj2[key]) {
                  return false;
              }
          }
      }
      return true;
    },
    dialogSure(){      
      //检查条件题目和选项是否完整
      try {
        this.checkedList.forEach(row=>{
          if(!row.subjectNo){
            throw new Error(`请选择关联题目`);
          }
          if(!row.subjectOption||row.subjectOption.length<1){
            throw new Error(`请选择关联题目的选项`);
          }
        })
      }catch (e) {
        this.$message.error(e.message);
        return;
      }
      this.getBranchList()
      this.emptyBranch()
      this.addConnectVisible=false
    },
    getBranchList(){//处理规则
      this.checkedList.forEach(item => {
          // 对 subjectOption 数组进行排序
          item.subjectOption.sort((a, b) => {
              return Number(a) - Number(b);
          });
      });
      if(this.branchListIndex>-1){
        let list=this.branchList[this.branchListIndex].subjectNos
        this.branchList[this.branchListIndex].rule = this.checkedList;
        this.branchList[this.branchListIndex].logicSymbol = this.logicSymbol;
        this.branchList[this.branchListIndex].subjectNos =[...new Set([...list,...this.batchObj.subjectNos,this.currentSubject.subjectNo])];
        let subjectNos=[...new Set([...list,...this.batchObj.subjectNos,this.currentSubject.subjectNo])]
        for (let i = 0; i < this.branchList.length; i++) {
          if (i === this.branchListIndex) {
              continue;
          }
          let currentSubjectNos = this.branchList[i].subjectNos;
          // 过滤掉与 subjectNos 重复的项
          this.branchList[i].subjectNos = currentSubjectNos.filter(num =>!subjectNos.includes(num));          
         
        }
        this.branchList = this.branchList.filter(item => item.subjectNos.length > 0);
      }else {
        let subjectNos=[this.currentSubject.subjectNo,...this.batchObj.subjectNos]
        for (let i = 0; i < this.branchList.length; i++) {
          let currentSubjectNos = this.branchList[i].subjectNos;
          // 过滤掉与 subjectNos 重复的项
          this.branchList[i].subjectNos = currentSubjectNos.filter(num =>!subjectNos.includes(num));
          
        }
        this.branchList = this.branchList.filter(item => item.subjectNos.length > 0);
        this.branchList.push({
          logicSymbol: this.logicSymbol,
          rule: this.checkedList,
          subjectNos:subjectNos
        });
      }
      
      //如果subjectNos中的值和arr中subjectNos的值重复，去掉arr中subjectNos里重复的项
      //如果this.branchList中属性的checkedList完全相同，则是重复规则，应该合并属性的subjectNos并去重
      console.log('getBranchList',this.branchList)

    },
    emptyBranch(){
      this.checkedList=[]
      this.logicSymbol='1'
      this.batchObj={
        isTopExpand:true,
        isExpand:false,
        start:'',//前
        end:'',//后
        subjectNos:[],//选择的题目
      }
    },
    dialogCancel(){
      this.emptyBranch()
      this.addConnectVisible=false
    },
    addConnect(row,idx){//connectdialog
      this.checkedList=[]
      this.currentSubjectIndex=idx
      this.currentSubject=row
      let num=row.subjectNo//题目的编号，通过编号寻找是否有规则
      let index = this.branchList.findIndex(item => item.subjectNos.includes(num));
      this.branchListIndex=index
      let foundItem = index!== -1? cloneDeep(this.branchList[index]) : null;
      let subjectNos=null
      if(foundItem){//编辑
        this.logicSymbol=foundItem.logicSymbol
        this.checkedList=foundItem.rule
        subjectNos=foundItem.subjectNos
        this.batchObj.subjectNos=subjectNos.filter(item=>item!==this.currentSubject.subjectNo)
        
      }else{
        let obj={
          subjectNo:'',//前置题目序号，
          subjectOption:[],//选项
        }
        this.checkedList=[obj]
        this.batchObj.subjectNos=[]
      }
      this.getOption(idx,subjectNos)
      this.addConnectVisible = true
    },
    getOption(idx,subjectNos){
      if(idx==-1){//从xxchange进
        idx=this.branchListIndex
      }else{
        let list=this.pageForm.subjectList.slice(0,idx)
        this.qzOptions=list.filter((item,index)=>{
          if((item.subjectType=='单选题'||item.subjectType=='多选题')&&item.interactType=='1'){
            item.label=(index+1)+'. '+item.subjectTitle
          }
          return (item.subjectType=='单选题'||item.subjectType=='多选题')&&item.interactType=='1'
        })
      }
      let subjectList=cloneDeep(this.pageForm.subjectList)
      let arr=subjectList.map((item,index)=>{
        item.label=(index+1)+'. '+item.subjectTitle
        // 拿到当前题的条件应用题，根据subjectNo匹配，已应用的禁用不可选择
        if(subjectNos){
          let index = subjectNos.findIndex(obj => obj==item.subjectNo);
          item.disabled = index!== -1
        }
       
        return item
      })
      this.bhList=(idx)<arr.length?arr.slice(idx+1):[]
      
    },
    seeAllConnect(){//addConnectVisible
      this.pageShow = false;
      this.$refs.questionConnect.connectVisible = true;
    },
    subjectScroll(e) {
      // 获取元素
      const contentRef = document.getElementById('contentRef');
      
      if(e>0){
        contentRef.scrollTo({
          top: 0,
          behavior: 'smooth' // 平滑滚动
        });
      }else{
        contentRef.scrollTo({
            top: contentRef.scrollHeight,
            behavior: 'smooth' // 平滑滚动
        });
      }
    },
    handleInput(val) {//修改题目排序 affectBranch
      let value = val.replace(/[^\d]/g,'');
      if (value === '') {
        this.subjectForm.orderNum = '';
        return;
      }
      if (parseInt(value) <= 0) {
        this.subjectForm.orderNum = '';
      } else {
        this.subjectForm.orderNum = value;
      }
      
      
    },
    getSjFilters(value){
      let str = '';
      let lookUp = {
        '1': '个核算月内',
        '2': '个自然月内',
        '3': '天内',
      };
      if(value){
        str=lookUp[value]
      }
      return str
    },
    addRule(){
      let obj={
        personRule:'',
        dateRule:'',
        dayNum:'',
        customerRule:'',
        maxValue:'',
        ruleDesc:'',
        tips:''
      }
      if(this.pageForm.surveyExecuteRules&&this.pageForm.surveyExecuteRules.length>0){
        if(this.checkConfig()){
          this.pageForm.surveyExecuteRules.push(obj)
        }
      }else{
        this.pageForm.surveyExecuteRules=[]
        this.pageForm.surveyExecuteRules.push(obj)
      }
      
      
    },
    deleteRule(index){
      if(this.isDetail){
        return
      }
      this
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          this.pageForm.surveyExecuteRules.splice(index,1)
        })
    },
    checkConfig(){
      try{
        let list=this.pageForm.surveyExecuteRules
        this.pageForm.surveyExecuteRules.forEach((item,index)=>{
          if(!item.personRule&&!item.dateRule&&!item.customerRule){
            throw new Error(`人员条件、时间条件、客户条件至少选择一种`);
          }
          if((item.dateRule&&!item.dayNum)||(!item.dateRule&&item.dayNum)){
            throw new Error('请填写完整时间条件')
          }
          if(!item.maxValue){
            throw new Error('请填写最大份数')
          }
          if(!item.tips){
            throw new Error('请填写拦截提示语')
          }
        })
        
        for (let i = 0; i < list.length; i++) {
          for (let j = i + 1; j < list.length; j++) {
            if (list[i].personRule === list[j].personRule && list[i].dateRule === list[j].dateRule && list[i].customerRule === list[j].customerRule) {
              
              throw new Error('同一规则请勿重复')
            }
            if ((list[i].dateRule&&list[j].dateRule)&&(list[i].dateRule!==list[j].dateRule)&&(list[i].dateRule!=3&&list[j].dateRule!=3)) {
            
              throw new Error('同一问卷的月份规则请保持一致')
            }
          }
        }
      } catch (error) {
        this.$message.error(error.message);
        return false;
      }
      return true
    },
    validateInput(row,attr) {
      let value = row[attr];
      if (/^\d+$/.test(value) && value > 0) {
        // 满足大于 0 的正整数条件
      } else {
        row[attr] = '';
      }
      this.$forceUpdate()
    },
    handleSelecConfig(row, index,attr) {
      let str=''
      let personRule=this.getNameByKey(row.personRule,'人员条件')
      let dateRule=(row.dayNum&&row.dateRule)?(row.dayNum + this.getSjFilters(row.dateRule)):''
      let customerRule=this.getNameByKey(row.customerRule,'客户条件')
      
      if((personRule||customerRule||(row.dayNum&&row.dateRule))&&row.maxValue){
        str='当前问卷' + personRule + dateRule + customerRule + '最多提交' + row.maxValue + '份'
      }
      this.pageForm.surveyExecuteRules[index].ruleDesc = str;
      this.$forceUpdate()
    },
    getNameByKey (name, key) {
      let list = this.getCodeListByKey(key);
      let lisArr = list.filter(item => item.value == name);
      return lisArr.length ? lisArr[0].text : '';
    },
    getDictList(type){
      let that=this
      let req = {
        pageIndex: 1,
        pageSize: -1,
      };
      that.api.postJson(`/${serverConfig.msConfigureService}/dict/data/get-class-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.dictList = res.data.data.records||[];
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    getRowKeys(row) {
      return row.guid;
    },
    selectDisableRoom(row) {
      if (
        this.pageForm.isSharing !== '1'
      ) {
        return true;
      }
    },
    onPreview() {
      this.srcLists=[this.url]
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    //移动端预览
    mobileView() {
      if (!this.pageForm.surveyTitle) {
        this.$message.error('请填写问卷标题');
        return;
      }
      if (!this.pageForm.surveyDesc) {
        this.$message.error('请填写问卷描述');
        return;
      }
      if (!this.pageForm.subjectList.length) {
        this.$message.error('请添加问卷题目');
        return;
      }
      this.pageShow = false;
      this.$refs.mobileSurvey.mobileShow = true;
    },
    //清空题目
    clearSubject() {
      if (!this.pageForm.subjectList.length) {
        this.$message.error('暂无题目');
        return;
      }
      this.$confirm('即将清空所有题目，确定此操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.pageForm.subjectList = [];
        })
        .catch(() => {});
    },
    pageClose(val) {
      this.pageShow = true;
    },
    getSelectItems(list) {
      var str = '';
      if (list && list.length > 0) {
        list.forEach((item, index) => {
          str = str + item.text + '、';
        });
        var reg = /、$/gi;
        str = str.replace(reg, '');
      }
      return str || '-';
    },
    //获取详情
    async getDetail() {
      let self = this;
      self.fullscreenLoading = true;
      let approveVO = null;
      try {
        approveVO = JSON.parse(this.$route.query.approveVO || '');
      } catch (e) { 
        
      }
      // 如果是从问卷审核页进入 使用新接口，否则使用旧接口
      const isFromReview = this.$route.query.from === 'questionnaireReview';
      let apiFn = null;
      let queryParams = {};
      if (isFromReview && approveVO) {
        apiFn = getSurveyChangeNew;
        queryParams = {
          approveGuid: approveVO.approveGuid,
          bizGuid: approveVO.bizGuid,
        }
      } else {
        apiFn = getSurveyDetail;
        queryParams = {
          guid: this.pageForm.guid,
          serviceTenantGuid: localStorage.guid,
        };
      }
      await apiFn(queryParams).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            let data = res.data.data;
            self.pageForm.isPlatformTemplate = data.isPlatformTemplate||'N';
            self.pageForm.surveyLabelList = data.surveyLabelList;
            self.pageForm.surveyTitle = data.surveyTitle;
            self.pageForm.surveyDesc = data.surveyDesc;
            self.pageForm.surveyText = data.surveyText;
            self.pageForm.videoUrl = data.videoUrl;
            self.pageForm.organisationGuid = data.organisationGuid;
            self.pageForm.isSharing = data.isSharing;
            self.pageForm.isOpenProtocol = data.isOpenProtocol;
            self.pageForm.protocolKeyWord = data.protocolKeyWord;
            self.pageForm.subjectList = data.subjectList ? data.subjectList : [];
            self.pageForm.surveyState = data.surveyState;
            self.pageForm.notSelfSubmit = data.notSelfSubmit=='Y'?true:false;
            self.pageForm.isDraft = data.isDraft;
            self.pageForm.bizApproveState = data.bizApproveState;
            if(self.pageForm.subjectList.length>0&&!self.pageForm.subjectList[0].subjectNo){
              self.pageForm.subjectList.forEach((item, index) => {
                item.subjectNo = index + 1;
              });
            }
            if(data.surveyExecuteRules&&data.surveyExecuteRules.length>0){
              data.surveyExecuteRules.forEach(item=>{
                delete item.guid
                delete item.surveyTenantGuid
              }) 
            }
            self.pageForm.surveyExecuteRules=data.surveyExecuteRules||[]
            
            if (data.qualityCheckConfig) {
              self.pageForm.qualityCheckConfig = data.qualityCheckConfig;
            }
            if (data.surveyRuleConfig) {
              self.pageForm.surveyRuleConfig=data.surveyRuleConfig;
            }
            self.pageForm.approveVO = data.approveVO || null;
            // v25.1.6调查问卷需求 兼容以前的数据，没有isSimpleFastAdd的默认传N，勾选完整资料建档
            if(data.surveyRuleConfig&&data.surveyRuleConfig.visitRight && data.surveyRuleConfig.visitRight.isFastAdd === 'Y' && !self.pageForm.surveyRuleConfig.visitRight.isSimpleFastAdd) {
                self.pageForm.surveyRuleConfig.visitRight.isSimpleFastAdd= "N"
              }
            if (data.surveyRuleConfig&&data.surveyRuleConfig.visitRight&&data.surveyRuleConfig.visitRight.visitRadioList.length>0) {
              self.visitRadioList = data.surveyRuleConfig.visitRight.visitRadioList;
              
            }
            if(data.surveySubjectRules&&data.surveySubjectRules.length>0){
              data.surveySubjectRules.forEach(item=>{
                delete item.guid
                delete item.surveyTenantGuid
              })
              
            }
            self.branchList=data.surveySubjectRules||[]
           
            // 问卷题目配置
            if(self.pageForm.subjectList.length>0){
              self.pageForm.subjectList.forEach(item=>{
                if((item.subjectType == '单选题'||item.subjectType == '多选题')&&!item.subjectItemType){
                  item.subjectItemType='1'
                  item.interactType='1'
                }
              })
            }
            
            if (self.$route.query.type != 0) {
              self.pageForm.tenantGuid = data.tenantGuid;
              self.pageForm.tenantName = data.tenantName;
              self.getOrganisation(self.pageForm.tenantGuid);
              let organisationName = data.organisationName;
              let organisationGuid = data.organisationGuid;
              if (organisationName && organisationName.length) {
                organisationName.forEach((item, index) => {
                  self.departmentList.push({
                    guid: organisationGuid[index],
                    organisationName: item,
                  });
                });
              }
              self.departmentSure(true);
            } else {//复制
              self.pageForm.organisationGuid = [];
              self.pageForm.guid = null;
            }
            self.originalSubjectList = JSON.parse(JSON.stringify(self.pageForm.subjectList));
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取当期状态
    getCurrentStatus(guid) {
      let self = this;
      self.fullscreenLoading = true;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/survey/tenant/check-task-time?guid=${guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            let data = res.data.data;
            console.log('当期状态',data);
            this.isCurrent=data
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取所有问卷
    getSurveyList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        surveyTitle: self.surveyTitle,
        isDraft: 'N',
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.surveyList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取验证方式
    getValidateList(type,flg) {
      // 这里需要根据题型获取
      let self = this;
      let query = {
        subjectType:type,
      };
      self.api.postJson(`/${serverConfig.msConfigureService}/subject-validate-rule/get-subject-rule`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.validateList = res.data.data||[];
          if(type=='时间'){
            if(flg=='child'){
              this.childForm.validateGuid=self.validateList[0].validateRuleGuid
            }else{
              this.subjectForm.validateGuid=self.validateList[0].validateRuleGuid
            }
            
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取标签列表
    getLabelList(name) {
      let self = this;
      let query = {
        bizState: 'Y',
        labelName: name
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/subject-stock/label/get-tree`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.labelList = res.data.data;
          let data = JSON.parse(JSON.stringify(res.data.data)) || [];
          self.labelAddList = data;
          if (name) {
            self.labelAddList.forEach((i) => {
              if (i.labelName == name) {
                this.subjectForm.subjectLabelGuid = i.guid;
              }
            });
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取客户对象列表
    getCustomerList() {
      let self = this;
      this.visitRadioList = [];
      let code='WJDC'
      self.api
        .get(`/${serverConfig.msSalesPerformService}/dict/data/get-dict?functionCode=${code}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let list = JSON.parse(JSON.stringify(res.data.data));
            list.forEach((item) => {
              item.name = item.text;
              item.type = item.value;
              item.competenceParam = 'CUSTOMER_GS';
            });
            self.visitRadioList = list;
            
            this.getSendTenantList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    
    //添加标签
    addLabel() {
      if (!this.labelName) {
        this.$message.error('请输入标签名！');
        return;
      }
      let query = {
        tenantGuid: localStorage.guid,
        labelName: this.labelName,
      };
      this.api.postJson(`/${serverConfig.msSalesPerformService}/subject-stock/label/add`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.subjectForm.subjectLabelGuid = null;
          this.getLabelList(this.labelName);
          this.$message.success('添加标签成功！');
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //手动题目-获取调研对象
    getTargetList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '调研对象',
        // tenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data.records || null;
          if (data) {
            let arr = [];
            let newArr = [];
            data.forEach((i, index) => {
              let obj = {
                label: i.paramName,
                value: i.paramValue,
              };
              arr.push(obj);
              let objData = {
                text: i.paramName,
                orderNum: Number(index)+1,
                value: i.paramValue,
                isCorrect: null,
              };
              newArr.push(objData);
            });
            this.targetOption = arr;
            this.subjectForm.selectItems = newArr;
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getSubjectLabelText(subject) {
      if (!subject) return '';
      // if (subject.labelName) return subject.labelName;
      if (!subject.subjectLabelGuid) return '';
      const findLabelPath = (list, guid, parents = []) => {
        if (!list || !list.length) return '';
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          const currentPath = parents.concat(item.labelName);
          if (item.guid == guid) {
            return currentPath.filter(Boolean).join('/');
          }
          const childPath = findLabelPath(item.children, guid, currentPath);
          if (childPath) return childPath;
        }
        return '';
      };
      return findLabelPath(this.labelAddList, subject.subjectLabelGuid);
    },
    //手动题目-添加题目
    addSubject(type, item, index, isView = false) {
      this.delXxObj={}//编辑进来的时候置空
      this.subjectView = isView;
      //题目编辑
      if (type == 1) {
        this.subjectType = 1;
        this.subjectVisible = true;
        this.subjectForm = cloneDeep(item);
        if(!this.subjectForm.pictUrl){
          this.subjectForm.pictUrl=[]
        }
        this.subjectForm.disabledOrderNum=this.isUsed(this.subjectForm)||this.isRely(this.subjectForm)
        this.subjectForm.disabledChange=this.isRely(this.subjectForm)
       
        this.oldSubjectType=item.subjectType
        if(item.subjectItemType=='4'){//平台字典
          this.subjectForm.hasChild = this.hasChildArray(item.dictGuid)
          let dictName=''
          this.dictList.filter(obj=>{
            if(obj.guid==item.dictGuid){//字典名称
              dictName=obj.dictTypeName
            }
          })
          let data=this.getCodeListByKey(dictName)
          this.targetOption=data
        }
        if(item.subjectType){
          this.getValidateList(item.subjectType)
        }
        this.currentSubjectIndex = index;
        this.subjectEdit = !isView;
        //题目新增
      } else if (type == 2) {
        this.subjectView = false;
        let num
        let maxNo
        if(this.pageForm.subjectList){
          num=this.pageForm.subjectList.length>0?(Number(this.pageForm.subjectList[this.pageForm.subjectList.length-1].orderNum)+1):(Number(this.pageForm.subjectList.length)+1)
          maxNo=this.pageForm.subjectList.length>0?Math.max(...this.pageForm.subjectList.map(item => Number(item.subjectNo))):0
        }
        if (this.currentSubjectIndex > -1) {
          this.subjectForm = {
            subjectNo:maxNo+1,
            subjectTitle: '',
            subjectType: '',
            orderNum: num,
            isRequired: 'Y',
            inputText: '',
            otherInput: null,
            valueSelect: [],
            selectItems: [],
            subjectLabelGuid: null,
            isValidateUnique: 'N',
            validateGuid:"", //验证方式
            subjectItemType:'',//题型分类
            dictGuid:'',//字典名称
            dictName:'',//字典名称
            interactType:'',//交互类型
            hasChild:false,//是否二级字典
            isSupportAll:false,//支持全部
            pictUrl:[],//示例图片
          };
        }
        this.subjectForm = {
            subjectNo:maxNo+1,
            subjectTitle: '',
            subjectType: '',
            orderNum: num,
            isRequired: 'Y',
            inputText: '',
            otherInput: null,
            valueSelect: [],
            selectItems: [],
            subjectLabelGuid: null,
            isValidateUnique: 'N',
            validateGuid:"", //验证方式
            subjectItemType:'',//题型分类
            dictGuid:'',//字典名称
            dictName:'',//字典名称
            interactType:'',//交互类型
            hasChild:false,//是否二级字典
            isSupportAll:false,//支持全部
            pictUrl:[],//示例图片
          };
        this.currentSubjectIndex = -1;
        this.subjectType = 1;
        this.subjectEdit = false;
        this.subjectVisible = true;
        //自动分配
      } else if (type == 3) {
        this.subjectView = false;
        this.automaticVisible = true;
      }
    },
    //手动题目-调研对象-题目类型
    subjectTypeChange(val) {
      if (val == '调研对象') {
        this.subjectForm.isValidateUnique = 'N';
        this.subjectForm.selectItems = [];
        this.subjectForm.validateGuid=''
        this.subjectForm.subjectItemType=''
        this.subjectForm.dictGuid=''
        this.subjectForm.dictName=''
        this.subjectForm.interactType=''
        this.getTargetList();
      }else if (val == '填写日期') {
        this.pageForm.subjectList=this.pageForm.subjectList.length?this.pageForm.subjectList.map(item=>{
          item.orderNum=Number(item.orderNum) + 1
          return item
        }):[]
        // this.subjectForm.orderNum = 1;
        this.subjectForm.isRequired = 'Y';
        this.subjectForm.isValidateUnique = 'N';
        this.subjectForm.selectItems = [];
        this.subjectForm.validateGuid=''
        this.subjectForm.subjectItemType=''
        this.subjectForm.dictGuid=''
        this.subjectForm.dictName=''
        this.subjectForm.interactType=''
        
      }else if (val.indexOf('上传照片') > -1){
        this.subjectForm.pictUrl=[]
      } else { 
        let flg=this.oldSubjectType&&this.oldSubjectType=='单选题'&&val=='多选题'?true:this.oldSubjectType&&this.oldSubjectType=='多选题'&&val=='单选题'?true:false
        if(!flg){//单选多选切换不清空val!=='单选题'&&val!=='多选题'&&
          this.subjectForm.isValidateUnique = 'N';
          this.subjectForm.selectItems = [];
          this.subjectForm.validateGuid=''
          this.subjectForm.subjectItemType=''
          this.subjectForm.dictGuid=''
          this.subjectForm.dictName=''
          this.subjectForm.interactType=''
        }
        
      }
      this.oldSubjectType=val
      this.getValidateList(val)
    },
    subjectItemTypeChange(type){
      if(type=='child'){
        this.childForm.selectItems = [];
        this.childForm.interactType = ''
        this.childForm.dictName = ''
        this.childForm.dictGuid = ''
      }else{
        this.subjectForm.selectItems = [];
        this.subjectForm.interactType = ''
        this.subjectForm.dictName = ''
        this.subjectForm.dictGuid = ''
      }
      
    },
    interactTypeChange(type){
      if(type=='child'){
        if(this.childForm.selectItems&&this.childForm.selectItems.length>0){
          this.childForm.selectItems.forEach(item=>{
            item.isAdd=false
            item.isAddWrite=false
          })
        }
      }else{
        if(this.subjectForm.selectItems&&this.subjectForm.selectItems.length>0){
          this.subjectForm.selectItems.forEach(item=>{
            item.isAdd=false
            item.isAddWrite=false
            
          })
        }
      }
      
    },
    // 字典名称
    dictChange(val,type){
      let dictName=''
      this.dictList.filter(item=>{
        if(item.guid==val){
          dictName=item.dictTypeName
        }
      })
      if(type=='child'){
        this.childTargetOption=[]
        this.childForm.selectItems=[]
        this.childForm.dictName=dictName
      }else{
        this.targetOption=[]
        this.subjectForm.selectItems=[]
        this.subjectForm.dictName=dictName
      }
      let data=this.getCodeListByKey(dictName)
      if(data.length>0){
        let arr=[],newArr=[]
        data.forEach((i, index) => {
          let objData = {
            text: i.text,
            orderNum: Number(index)+1,
            value: i.value,
            isCorrect: null,
            isAdd:false,
            isAddWrite:false,
            child:i.childDictList||null
          };
          newArr.push(objData);
        })
        if(type=='child'){
          this.childTargetOption=data
          this.childForm.selectItems=newArr
          this.childForm.hasChild=this.hasChildArray(val)
        }else{
          this.targetOption = data;
          this.subjectForm.selectItems = newArr;
          this.subjectForm.hasChild=this.hasChildArray(val)
        }
       
      }
      
      
    },
    hasChildArray(val){
      let dictName=''
      this.dictList.filter(item=>{
        if(item.guid==val){
          dictName=item.dictTypeName
        }
      })
      
      let data=this.getCodeListByKey(dictName)
      
      let flag=false
      flag=data.some(item => item.hasOwnProperty('childDictList') && Array.isArray(item.childDictList))
      return flag
    },
    // 调研对象的修改
    changeSubjectObj(row){
      this.targetOption.forEach(item => {
        if(item.value == row.value){
          row.text=item.label;
        }
      })
      
    },
    // 是否追加
    addChange(row){
      row.subjectItem=null
      row.isAddWrite=false
      this.$forceUpdate()
    },
    // 子答案的题目类型
    childTypeChange(val){
      let flg=this.oldChildType&&this.oldChildType=='单选题'&&val=='多选题'?true:this.oldChildType&&this.oldChildType=='多选题'&&val=='单选题'?true:false
      if(!flg){
        this.childForm.isValidateUnique = 'N';
        this.childForm.selectItems = [];
        this.childForm.validateGuid = "";
        this.childForm.dictGuid = "";
        this.childForm.dictName = "";
        this.childForm.interactType = "";
        this.childForm.cueWords = "";
        this.childForm.subjectItemType = "";
      }else{
        this.childForm.validateGuid = "";
        this.childForm.cueWords = "";
      }
      
      this.oldChildType=val
      this.getValidateList(val,'child')
    },
    //手动题目-添加题目选项
    addSubjectItem() {
      let obj = {
        text: '',
        orderNum: '',
        value: '',
        isCorrect: null,
      };
      if(this.subjectForm.subjectType !== '调研对象'){
        obj={
          text: '',
          orderNum: '',
          value: '',
          isCorrect: null,
          isAdd:false,
          isAddWrite:false,
          inputText:''
        }
      }
      
      this.subjectForm.selectItems.push(obj);
    },
    // 添加子答案选项
    addChildItem(){
      if(this.subjectReadonly){
        return
      }
      let obj = {
        text: '',
        orderNum: '',
        value: '',
      };
      
      this.childForm.selectItems.push(obj);
    },
    
    //题目/题目选项排序-向下
    sortDownField(type, row, index) {
      if(this.subjectReadonly){
        return
      }
      let orderNumFlag = row.orderNum||(Number(index) + 1);
      if (type == 'field') {//题目编辑弹窗里选项的排序
        
        if(this.isRely(this.subjectForm)){//被当做条件
          this.changeXxSort(this.subjectForm,index,index+1)
        }
        this.subjectForm.selectItems[index + 1].orderNum = orderNumFlag;
        this.subjectForm.selectItems.splice(index, 1);
        this.subjectForm.selectItems.splice(index + 1, 0, row);
      } else if(type == 'child'){
        // this.childForm.selectItems[index + 1].orderNum = orderNumFlag;
        this.childForm.selectItems.splice(index, 1);
        this.childForm.selectItems.splice(index + 1, 0, row);
      }else{//题目上下移要判断
        if(this.affectBranch(row,index+1,orderNumFlag)){//拦截
          this.$confirm('排序修改会影响题目关联条件，继续操作将会删除相关条件逻辑，确定继续吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let num=this.pageForm.subjectList[index+1].subjectNo
            for (let i = 0; i < this.branchList.length; i++) {
                let currentSubjectNos = this.branchList[i].subjectNos;
                console.log('currentSubjectNos',currentSubjectNos);
                // 过滤掉和 num 相同的项
                this.branchList[i].subjectNos = currentSubjectNos.filter(item => Number(item) !== Number(num));
                 // 检查过滤后的 subjectNos 是否为空
                if (this.branchList[i].subjectNos.length === 0) {
                    // 如果为空，删除当前项
                    this.branchList.splice(i, 1);
                    // 由于删除了一项，数组长度减 1，所以需要将索引 i 减 1
                    i--;
                }
            }
            
            this.pageForm.subjectList[index].orderNum = this.pageForm.subjectList[index + 1].orderNum;
            this.pageForm.subjectList[index + 1].orderNum = orderNumFlag;
            this.pageForm.subjectList.splice(index, 1);
            this.pageForm.subjectList.splice(index + 1, 0, row);
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        }else{
          this.pageForm.subjectList[index].orderNum = this.pageForm.subjectList[index + 1].orderNum;
          this.pageForm.subjectList[index + 1].orderNum = orderNumFlag;
          this.pageForm.subjectList.splice(index, 1);
          this.pageForm.subjectList.splice(index + 1, 0, row);
        }
        
      }
    },
    //题目/题目选项排序-向上
    sortUpField(type, row, index) {
      if(this.subjectReadonly){
        return
      }
      let orderNumFlag = row.orderNum;
      if (type == 'field') {
        if(this.isRely(this.subjectForm)){//被当做条件
          this.changeXxSort(this.subjectForm,index,index-1)
        }
        this.subjectForm.selectItems[index - 1].orderNum = orderNumFlag;
        this.subjectForm.selectItems.splice(index, 1);
        this.subjectForm.selectItems.splice(index - 1, 0, row);
      }else if(type == 'child'){
        this.childForm.selectItems[index - 1].orderNum = orderNumFlag;
        this.childForm.selectItems.splice(index, 1);
        this.childForm.selectItems.splice(index - 1, 0, row);
      } else {
        if(this.affectBranch(row,index,this.pageForm.subjectList[index - 1].orderNum)){//拦截
          this.$confirm('排序修改会影响题目关联条件，继续操作将会删除相关条件逻辑，确定继续吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let num=this.pageForm.subjectList[index].subjectNo
            for (let i = 0; i < this.branchList.length; i++) {
                let currentSubjectNos = this.branchList[i].subjectNos;
                console.log('currentSubjectNos',currentSubjectNos);
                // 过滤掉和 num 相同的项
                this.branchList[i].subjectNos = currentSubjectNos.filter(item => Number(item) !== Number(num));
                 // 检查过滤后的 subjectNos 是否为空
                if (this.branchList[i].subjectNos.length === 0) {
                    // 如果为空，删除当前项
                    this.branchList.splice(i, 1);
                    // 由于删除了一项，数组长度减 1，所以需要将索引 i 减 1
                    i--;
                }
            }
           
            this.pageForm.subjectList[index].orderNum = this.pageForm.subjectList[index - 1].orderNum;
            this.pageForm.subjectList[index - 1].orderNum = orderNumFlag;
            this.pageForm.subjectList.splice(index, 1);
            this.pageForm.subjectList.splice(index - 1, 0, row);
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        }else{
          this.pageForm.subjectList[index].orderNum = this.pageForm.subjectList[index - 1].orderNum;
          this.pageForm.subjectList[index - 1].orderNum = orderNumFlag;
          this.pageForm.subjectList.splice(index, 1);
          this.pageForm.subjectList.splice(index - 1, 0, row);
        }
        
      }
    },
    //题目选项-删除
    subjectFieldDel(index,type) {
      if(this.subjectReadonly){
        return
      }
      let str='删除后不可恢复，确定删除吗？'
      if(this.isRely(this.subjectForm)&&!type&&this.delXx(this.subjectForm,index)){
        str='该选项已作为条件关联，继续操作将会删除相关条件逻辑，确定继续吗？'
        
      }
      this
        .$confirm(str, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          if(type=='child'){
            this.childForm.selectItems.splice(index, 1);
          }else{
            if(this.isRely(this.subjectForm)&&!type){
              // 存一个对象，保存的时候再删除选项
              if(this.delXxObj.flg){
                this.delXxObj.idx.push(index)
              }else{
                this.delXxObj={
                  num:this.subjectForm.subjectNo,
                  idx:[index],
                  flg:true
                }
              }
              
            }
            this.subjectForm.selectItems.splice(index, 1);
            
          }
        })
     
      
    },
    // 题目选项-追加子答案规则
    setSelectAdd(row,idx){
      // 不清空上一次选择的子答案选项
      if(row.subjectItem && row.subjectItem.subjectType){//如果有子答案
        this.childForm = {
          subjectType: row.subjectItem.subjectType,
          inputText: row.subjectItem.inputText||'',
          valueSelect: row.subjectItem.valueSelect||[],
          selectItems: row.subjectItem.selectItems||[],
          isValidateUnique: row.subjectItem.isValidateUnique||'N',//校验唯一性
          validateGuid:row.subjectItem.validateGuid||"", //验证方式
          subjectItemType:row.subjectItem.subjectItemType||'',//题型分类
          dictGuid:row.subjectItem.dictGuid||'',//字典名称
          dictName:row.subjectItem.dictName||'',//字典名称
          interactType:row.subjectItem.interactType||'',//交互类型
          cueWords:row.subjectItem.cueWords||'',//提示语
          index:idx,
          hasChild:row.subjectItem.hasChild||false,//是否二级字典
          isSupportAll:row.subjectItem.isSupportAll||false,//是否二级字典

        }
      }else{
        this.childForm = {
          subjectType: '',
          inputText: '',
          valueSelect: [],
          selectItems: [],
          isValidateUnique: 'N',
          validateGuid: '',
          subjectItemType: '',
          dictGuid: '',
          dictName: '',
          interactType: '',
          cueWords: '',
          index: idx,
          hasChild: false,
          isSupportAll: false,
        }
      }
      // this.childForm = {
      //   subjectType: row.subjectItem.subjectType||'',
      //   inputText: row.subjectItem.inputText||'',
      //   valueSelect: row.subjectItem.valueSelect||[],
      //   selectItems: row.subjectItem.selectItems||[],
      //   isValidateUnique: row.subjectItem.isValidateUnique||'N',//校验唯一性
      //   validateGuid:row.subjectItem.validateGuid||"", //验证方式
      //   subjectItemType:row.subjectItem.subjectItemType||'',//题型分类
      //   dictGuid:row.subjectItem.dictGuid||'',//字典名称
      //   dictName:row.subjectItem.dictName||'',//字典名称
      //   interactType:row.subjectItem.interactType||'',//交互类型
      //   cueWords:row.subjectItem.cueWords||'',//提示语
      //   index:idx,
      // }
      this.oldChildType=(row.subjectItem && row.subjectItem.subjectType)||''
      if(row.subjectItem && row.subjectItem.subjectItemType=='4'){//平台字典
        this.childForm.hasChild = this.hasChildArray(row.subjectItem.dictGuid)
        let dictName=''
        this.dictList.filter(obj=>{
          if(obj.guid==row.subjectItem.dictGuid){//字典名称
            dictName=obj.dictTypeName
          }
        })
        let data=this.getCodeListByKey(dictName)
        this.childTargetOption=data
      }
      if(row.subjectItem && row.subjectItem.subjectType){
        this.getValidateList(row.subjectItem.subjectType,'child')
      }
      // this.childForm = row.subjectItem
      // 题型分类，自定义选项或平台字典
      
      this.selectAddVisible=true
     
      
    },
    // 子答案的弹框提交
    selectAddSubmit(){
      try {
          if (!this.childForm.subjectType) {
            throw new Error('请选择题目类型');
          }
          if (
            this.childForm.subjectType == '单选题' ||
            this.childForm.subjectType == '多选题'
          ) {
            if(!this.childForm.subjectItemType){
              throw new Error('请选择题型分类');
            }
            if(this.childForm.subjectItemType=='4' && !this.childForm.dictGuid){
              throw new Error('请选择字典名称');
            }
            if((this.childForm.subjectItemType=='1'||this.childForm.subjectItemType=='4') && !this.childForm.interactType){
              throw new Error('请选择交互方式');
            }
            if (this.childForm.subjectItemType=='1'&&!this.childForm.selectItems.length) {
              throw new Error('请添加选项');
            }
            this.childForm.selectItems.forEach((item) => {
              if (item.text == '') {
                throw new Error('请填写选项名称');
              }
            });
            for (var i = 0; i < this.childForm.selectItems.length; i++) {
              for (var j = i + 1; j < this.childForm.selectItems.length; j++) {
                if (this.childForm.selectItems[i].text == this.childForm.selectItems[j].text) {
                  throw new Error(this.childForm.selectItems[i].text + '，选项名称不能重复');
                }
              }
            }
          }
          if (
            this.childForm.subjectType == '单行填空题'){
              if (!this.childForm.validateGuid) {
                throw new Error('请选择验证输入方式');
              }
          }
          if (
            this.childForm.subjectType == '单行填空题'||
            this.childForm.subjectType == '多行填空题'){
              if (!this.childForm.cueWords) {
                throw new Error('请选择提示语');
              }
          }
          
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
        
        if (this.childForm.subjectType !== '单行填空题') {
          this.childForm.isValidateUnique = 'N';
        }
      let idx=this.childForm.index
      const selectItem = cloneDeep(this.childForm);
      // 追加的子类 如果是 单选题 | 多选题  value 为空，需要给一个默认值
      selectItem.selectItems = selectItem.selectItems.map((item, index) => {
        let value = item.value;
        if (SelectQuestionType.includes(item.subjectType) && !item.value) {
          value = SelectItemsValue[index];
        }
        return {
          ...item,
          value,
        }
      });
      this.subjectForm.selectItems[idx].subjectItem = selectItem
      
      this.$forceUpdate()
      this.selectAddVisible=false
    },
    //批量选题-点击模板
    clickSurveyList(guid) {
      this.surveyGuid = guid ? guid : null;
      this.getSubject(1);
    },
    //批量选题-清空搜索条件
    emptySelectSubject() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        surveyTenantGuid: this.surveyGuid,
        tenantGuid: localStorage.guid,
        labelGuid: null,
        subjectTitle: null,
        subjectType: null,
      };
    },
    //批量选题-获取题目
    getSubject(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.tableLoading = true;
      self.tableData = [];
      // self.page.tenantGuid = localStorage.guid;
      self.page.surveyTenantGuid = this.surveyGuid;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/list-subject`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //批量选题-选择题目
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item);
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getSubject();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getSubject();
    },
    //自动选题-选择分配方式
    automaticRadioChange(val) {
      if(val == 3){
        this.ruleList = [];
        this.automaticForm.ruleList = [];
      }else{
        this.labelSelectGuid = '';
      }
      this.automaticRadio = val;
    },
    //自动选题-选择标签-多选
    automaticSelectChange(val) {
      let arr = [];
      if (val?.length) {
        // 递归查找树结构中匹配的节点
        const findNode = (tree, targetGuid) => {
          for (let node of tree) {
            if (node.guid === targetGuid) {
              return node;
            }
            if (node.children?.length) {
              const found = findNode(node.children, targetGuid);
              if (found) return found;
            }
          }
          return null;
        };
        
        val.forEach((guid) => {
          const node = findNode(this.labelList, guid);
          if (node) {
            arr.push({
              labelGuid: node.guid,
              labelName: node.labelName,
              percent: 0,
            });
          }
        });
      }
      this.automaticForm.ruleList = arr;
    },
    //自动选题-选择标签-单选
    automaticSelectChangeOne(val){
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: 10,
        subjectLabelGuid:val
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/subject-stock/subject/list`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.labelTotalRows = res.data.data.totalRows;
         
        } else {
          self.$message.error(res.data.msg);
        }
      })
    },
    //级联选择器变化处理
    handleCascaderChange(val) {
      if (this.automaticForm.genRule == 3) {
        //单选模式（按题型选题）
        this.automaticSelectChangeOne(val);
      } else {
        //多选模式（平均分配/按占比分配）
        this.automaticSelectChange(val);
      }
    },
    //自动选题-提交
    automaticSubmit() {
      let sum = 0;
      if (!this.automaticForm.subjectTotal) {
        this.$message.error('请输入题目数量');
        return;
      }
      if (this.automaticForm.ruleList.length < 1 && !this.labelSelectGuid) {
        this.$message.error('请选择题目标签');
        return;
      }
      if(this.automaticForm.genRule !== 3){
        this.automaticForm.ruleList.forEach((m) => {
          sum = sum + Number(m.percent);
        });
      }
      if (sum !== 100 && this.automaticForm.genRule == 2) {
        this.$message.error('题目占比总数要等于100');
        return;
      }
      if ((this.automaticForm.subjectTotal > this.page.totalRows)&&this.automaticForm.genRule !== 3) {
        this.$message.error('输入数量不能大于总题目数');
        return;
      }
      let oneSum = 0;
      if(this.automaticForm.genRule == 3){
        this.subjectTypeList.forEach((m) => {
          oneSum = oneSum + Number(m.needNum);
        });
      }
      if(oneSum == 0&&this.automaticForm.genRule == 3){
        this.$message.error('请输入题目类型数量');
        return;
      }
      if ((oneSum > this.automaticForm.subjectTotal)&&this.automaticForm.genRule == 3) {
        this.$message.error('输入数量不能大于输入题目数');
        return;
      }
      this.subjectTypeList.forEach(o=>{
        let obj = {
          labelGuid:this.labelSelectGuid,
          subjectType:o.label,
          needNum:o.needNum
        }
        this.automaticForm.ruleList.push(obj)
      })
      // if (this.pageForm.isSharing == '1') {
      //   this.automaticForm.excludeSubjectType = ['调研对象', '客户名称'];
      // }
      let resultData = JSON.parse(JSON.stringify(this.automaticForm));
      resultData.tenantGuid = localStorage.guid;
      resultData.subjectTotal = Number(resultData.subjectTotal);
      if(this.automaticForm.genRule !== 3){
        resultData.ruleList.forEach((i) => {
          if (resultData.genRule == 1) {
            i.percent = Number((1 / resultData.ruleList.length).toFixed(2));
          } else if (i.percent > 0 && resultData.genRule == 2) {
            i.percent = Number(i.percent) / 100;
          }
        });
      }
      if (!this.pageForm.subjectList.length) {
        this.automaticSubmitPost('clear', resultData);
      } else {
        this.automaticVisible = false;
        this.$confirm('提交后，当前问卷已选题目是否清空？', '提示', {
          confirmButtonText: '清空',
          cancelButtonText: '不清空',
          distinguishCancelAndClose: true,
          showClose: true,
          type: 'warning',
        })
          .then(() => {
            this.automaticSubmitPost('clear', resultData);
          })
          .catch((action) => {
            if (action == 'close') {
              this.automaticVisible = true;
            } else {
              this.automaticSubmitPost('retain', resultData);
            }
          });
      }
    },
    //自动选题-请求
    automaticSubmitPost(type, resultData) {
      this.fullscreenLoading = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/subject-stock/subject/auto-gen`, resultData)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (!res.data.data.length) {
              this.$message.error('该标签暂无题目！');
              return;
            }
            if (type == 'clear') {
              this.pageForm.subjectList = [];
              this.pageForm.subjectList = res.data.data;
              if(this.pageForm.subjectList.length>0&&!this.pageForm.subjectList[0].subjectNo){
                this.pageForm.subjectList.forEach((item, index) => {
                  item.subjectNo = index + 1;
                });
              }
            } else {
              let list=res.data.data
              let maxNo
              maxNo=this.pageForm.subjectList.length>0?Math.max(...this.pageForm.subjectList.map(item => Number(item.subjectNo))):0
              list.forEach((item, index) => {
                item.subjectNo = index + 1 + maxNo;
              });
              this.pageForm.subjectList = this.pageForm.subjectList.concat(list);
            }
            
            this.automaticVisible = false;
            this.automaticForm = {
              tenantGuid: null,
              subjectTotal: null,
              genRule: 1,
              ruleList: [],
            };
            this.ruleList = [];
            this.subjectTypeList.forEach(o=>{
              o.needNum = 0;
            })
            this.$message.success('添加成功');
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //添加题目-提交
    subjectSubmit() {
      //手动
      if (this.subjectType === 1) {
        try {
          if (!this.subjectForm.subjectTitle) {
            throw new Error('请填写题目标题');
          }
          if (!this.subjectForm.subjectType) {
            throw new Error('请选择题目类型');
          }
          if (!this.subjectForm.subjectLabelGuid) {
            throw new Error('请选择题目标签');
          }
          if (
            this.subjectForm.subjectType == '调研对象'
          ) {
            if (!this.subjectForm.selectItems.length) {
              throw new Error('请添加选项');
            }
            this.subjectForm.selectItems.forEach((item) => {
              if (item.text == '') {
                throw new Error('请填写选项名称');
              }
            });
            for (var i = 0; i < this.subjectForm.selectItems.length; i++) {
              for (var j = i + 1; j < this.subjectForm.selectItems.length; j++) {
                if (this.subjectForm.selectItems[i].text == this.subjectForm.selectItems[j].text) {
                  
                  throw new Error(this.subjectForm.selectItems[i].text + '，选项名称不能重复');
                }
              }
            }
          }
          if(this.subjectForm.subjectType == '选择区域' && !this.subjectForm.validateGuid && this.pageForm.isSharing == '0'){
            throw new Error('请选择验证输入方式');
          }
          if (
            this.subjectForm.subjectType == '单行填空题'||
            this.subjectForm.subjectType == '年月'||
            this.subjectForm.subjectType == '年月日'||
            this.subjectForm.subjectType == '填写日期'||
            this.subjectForm.subjectType == '定位签到'
          ){
              if (!this.subjectForm.validateGuid) {
                throw new Error('请选择验证输入方式');
              }
          }
          if (
            this.subjectForm.subjectType == '单选题' ||
            this.subjectForm.subjectType == '多选题'
          ) {
            if (this.subjectForm.subjectItemType=='1'&&!this.subjectForm.selectItems.length) {
              throw new Error('请添加选项');
            }
            if(this.subjectForm.selectItems.length>0){
              this.subjectForm.selectItems.forEach((item) => {
                if (item.text == '') {
                  throw new Error('请填写选项名称');
                }
              });
            }
            
            for (var i = 0; i < this.subjectForm.selectItems.length; i++) {
              for (var j = i + 1; j < this.subjectForm.selectItems.length; j++) {
                if (this.subjectForm.selectItems[i].text == this.subjectForm.selectItems[j].text) {
                  throw new Error(this.subjectForm.selectItems[i].text + '，选项名称不能重复');
                }
              }
            }
            if(!this.subjectForm.subjectItemType){
              throw new Error('请选择题型分类');
            }
            if(this.subjectForm.subjectItemType=='4' && !this.subjectForm.dictGuid){
              throw new Error('请选择字典名称');
            }
            if((this.subjectForm.subjectItemType=='1'||this.subjectForm.subjectItemType=='4') && !this.subjectForm.interactType){
             
              throw new Error('请选择交互方式');
            }
            
            this.subjectForm.selectItems.forEach((item) => {
              
              if (item.isAdd &&(!item.subjectItem||!item.subjectItem.subjectType)) {
                throw new Error('请设置子答案规则');
              }
            });
            
          }
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
        
        if (this.subjectForm.subjectType !== '单行填空题') {
          this.subjectForm.isValidateUnique = 'N';
        }
        if(this.subjectForm.interactType!=='1'&&this.subjectForm.subjectType !== '单选题' && this.subjectForm.subjectType === '多选题'){
          // 交互方式不为平铺的时候
          if(this.subjectForm.selectItems&&this.subjectForm.selectItems.length>0){
            this.subjectForm.selectItems.forEach(item => {
              item.isAdd = false;
              item.isAddWrite = false;
              item.subjectItem={}
            });
          }
        }
        if (this.subjectEdit) {
          this.pageForm.subjectList[this.currentSubjectIndex] = this.subjectForm;
          this.pageForm.subjectList.sort((a, b) => {
            return a.orderNum - b.orderNum;
          });
          this.$message.success('修改成功');
        } else {
          this.pageForm.subjectList.push(this.subjectForm);
          this.pageForm.subjectList.sort((a, b) => {
            return a.orderNum - b.orderNum;
          });
          this.$message.success('添加成功');
        }
        this.subjectForm = {
          subjectTitle: '',
          subjectType: '',
          orderNum: '',
          isRequired: 'Y',
          inputText: '',
          otherInput: null,
          valueSelect: [],
          selectItems: [],
          subjectLabelGuid: null,
          isValidateUnique: 'N',
          validateGuid:"", //验证方式
          subjectItemType:'',//题型分类
          dictGuid:'',//字典名称
          dictName:'',//字典名称
          interactType:'',//交互类型
          hasChild:false,//是否二级字典
          isSupportAll:false,//支持全部
        };
      } else {
        //批量选择
        try {
          if (!this.multipleSelection.length) {
            throw new Error('请选择题目');
          }
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
        if (!this.pageForm.subjectList.length) {
          this.pageForm.subjectList = this.multipleSelection;
          // 要把subjectNo加进去
          this.pageForm.subjectList.forEach((item, index) => {
            item.subjectNo = index + 1;
          });
        } else {
          let maxNo
          maxNo=this.pageForm.subjectList.length>0?Math.max(...this.pageForm.subjectList.map(item => Number(item.subjectNo))):0
          // subjectNo:maxNo+1,
          this.multipleSelection.forEach((item, index) => {
            item.subjectNo = index + 1 + maxNo;
          });
          this.pageForm.subjectList = this.pageForm.subjectList.concat(this.multipleSelection);
        }
        this.multipleSelection = [];
        this.$refs.multipleTable.clearSelection();
        this.$message.success('添加成功');
      }
      this.childForm = {
        subjectType: '',
        inputText: '',
        valueSelect: [],
        selectItems: [],
        isValidateUnique: 'N',//校验唯一性
        validateGuid:"", //验证方式
        subjectItemType:'',//题型分类
        dictGuid:'',//字典名称
        dictName:'',//字典名称
        interactType:'',//交互类型
        cueWords:'',//提示语
        index:null,
        hasChild:false,//是否二级字典
        isSupportAll:false,//支持全部
      }
      
      if(this.delXxObj.flg){
        this.delXxSure(this.delXxObj.num,this.delXxObj.idx)
      }
      // 单选题 | 多选题 的时候 需要给 value 赋默认值
      this.pageForm.subjectList = this.pageForm.subjectList.map(item => {
        return {
          ...item,
          selectItems: item.selectItems.map((o, idx) => {
            let value = o.value;
            if (SelectQuestionType.includes(item.subjectType) && !o.value) {
              value = SelectItemsValue[idx];
            }
            return {
              ...o,
              value,
            }
          })
        }
      })
      this.subjectVisible = false;
    },
    //题目-删除
    delSubject(index) {
      let str='删除后不可恢复，确定删除吗？'
      let row=this.pageForm.subjectList[index]
      if(this.isRely(row)){
        str='该题目已作为条件关联，继续操作将会删除相关条件逻辑，确定继续吗？'
      }
      this
        .$confirm(str, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let num=row.subjectNo
          if(this.isRely(row)){//被作为条件
            for (let i = this.branchList.length - 1; i >= 0; i--) {
                const item = this.branchList[i];
                // 过滤掉 rule 中 subjectNo 等于 num 的项
                item.rule = item.rule.filter(ruleItem => Number(ruleItem.subjectNo)!== Number(num));
                // 检查 rule 数组长度是否为 0
                if (item.rule.length === 0) {
                    // 如果为 0，从 this_branchList 中移除该项
                    this.branchList.splice(i, 1);
                }
            }
          }
          if(this.isUsed(row)){//应用了条件
            for (let i = this.branchList.length - 1; i >= 0; i--) {
              let currentItem = this.branchList[i];
              // 过滤掉 subjectNos 中与 num 相同的项
              currentItem.subjectNos = currentItem.subjectNos.filter(item => Number(item) !== Number(num));

              // 检查过滤后的 subjectNos 长度是否为 0
              if (currentItem.subjectNos.length === 0) {
                  // 如果长度为 0，从 this_branchList 中移除该项
                  this.branchList.splice(i, 1);
              }
            }
          }
          
          this.$message.success('删除成功');
          this.pageForm.subjectList.splice(index, 1);
        })    
     
    },
    // 拦截提醒校验
    remindData(row,flg) {
      // flg为1是保存
      let that = this;
      
      try{
        // 选择客户或者选择其他机构的题型只能选择一项
      if(row.subjectList&&row.subjectList.length>0){
        let obj=null
        let obj1=null
        let obj2=null
        let arr=[]
        let list=[]
        row.subjectList.forEach(item=>{
          if(item.subjectType=='定位签到'){
            obj=item
          }
          if(item.subjectType=='调研对象'||
            item.subjectType=='选择医疗机构'||
            item.subjectType == '选择等级医院'||
            item.subjectType == '选择基层医疗'||
            item.subjectType == '选择药店'||
            item.subjectType == '选择商业公司'
          ){
            arr.push(item)
          }
          // 放下面一起了
          // else if(item.selectItems&&item.selectItems.length>0){
          //   //题目有选项且选项中有追加的题型为定位签到
          //   item.selectItems.forEach(items=>{
          //     if(items.subjectItem &&items.subjectItem.subjectType=='定位签到'){
          //       obj=items
          //     }
          //   })
          // }
          if(item.subjectType=='填写日期'
          ){
            list.push(item)
          }
          if(item.subjectType=='调研对象'){
            obj2=item
          }
          if(item.subjectType=='客户名称'){
            obj1=item
          }
          if(obj1&&!obj2){
            throw new Error('如果存在客户名称的题型,必须配置调研对象的题型')
          }
          if(item.selectItems&&item.selectItems.length>0){
            ////题目有选项
            item.selectItems.forEach(items=>{
              //items.subjectItem且选项中有追加的题型
              if(items.subjectItem &&items.subjectItem.subjectType=='定位签到'){
                obj=items
              }
              
              if(items.subjectItem &&
              (
              items.subjectItem.subjectType=='选择医疗机构'||
              items.subjectItem.subjectType=='选择等级医院'||
              items.subjectItem.subjectType=='选择基层医疗'||
              items.subjectItem.subjectType=='选择药店'||
              items.subjectItem.subjectType=='选择商业公司'
              )){
                arr.push(items)
              }
            })
          }
        })
        if(obj&&arr.length<1){//(有obj && 签到题型)
          throw new Error("如果定位签到的题型,必须配置以下这些题型中的一种:调研对象、选择医疗机构、选择等级医院、选择基层医疗、选择药店、选择商业公司");
        }
        if(arr.length>1){//(有obj && 签到题型)
          throw new Error("同一套问卷中以下这些题型只能选择一种:调研对象、选择医疗机构、选择等级医院、选择基层医疗、选择药店、选择商业公司");
        }
        if(list.length>1){//(填写日期)
          throw new Error("同一套问卷中'填写日期'题型只能选择一题");
        }
        // else if(list.length==1&&(row.subjectList[0].subjectType!=='填写日期'||row.subjectList[0].isRequired!=='Y')){
        //   throw new Error("'填写日期'题型必填，且为第一题");
        // }
      }
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      
      if((this.$route.query.type !== '1' && this.$route.query.type !== '3')||row.isDraft!=='N'){
        if(flg==1){
          this.saveReq(1)
        }else{
          this.saveReq()
        }
        
        return;
      }else{//编辑问卷（非草稿）
        if (!this.checkForm()) {
          return;
        }
        if(this.pageForm.surveyExecuteRules&&this.pageForm.surveyExecuteRules.length>0&&!this.checkConfig()){
          return;
        }
       
        let organisationGuid = [];
        let organisationName = [];
        this.departmentList.forEach((item) => {
          organisationGuid.push(item.guid);
          organisationName.push(item.organisationName);
        });
        
        let query={
          guid:row.guid,
          surveyTitle:row.surveyTitle,
          tenantGuid:row.tenantGuid,
          dataFrom:this.dataFrom,
          organisationGuid:organisationGuid,
          isDraft:flg==1?'Y':'N',
        }
        that.api.postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/check-task-publish`,query)
        .then((res) => {
          if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
            if(res.data.data){
              this.$confirm(res.data.data, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              if(flg==1){
                this.saveReq(1,1)
              }else{
                this.saveReq('',1)
              }
              // this.saveReq(2)
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作'
              });
            });
            }else{
              if(flg==1){
                this.saveReq(1)
              }else{
                this.saveReq()
              }
            }
            
          }else {
            that.$message.error(res.data.msg);
          }
        })
      }
      
      
    },
    checkForm() {
      if (!this.pageForm.isPlatformTemplate) {
        this.$message.error('请选择是否平台模板');
        return false;
      }
      if (this.pageForm.isPlatformTemplate=='N'&&!this.pageForm.tenantName) {
        this.$message.error('请选择应用公司');
        return false;
      }
      if (!this.pageForm.surveyTitle) {
        this.$message.error('请填写问卷标题');
        return false;
      }
      if (!this.pageForm.surveyDesc) {
        this.$message.error('请填写问卷说明');
        return false;
      }
      if (!this.pageForm.subjectList.length) {
        this.$message.error('请添加问卷题目');
        return false;
      }
      if (this.pageForm.isOpenProtocol == 'Y' && !this.pageForm.protocolKeyWord) {
        this.$message.error('请填写同意书关键字');
        return false;
      }
      if (this.pageForm.isOpenProtocol !== 'Y') {
        this.pageForm.protocolKeyWord = null;
      }
      if (
        this.pageForm.qualityCheckConfig.quantityCheckEnabled &&
        (!this.pageForm.qualityCheckConfig.quantityCheckLowLimit ||
          !this.pageForm.qualityCheckConfig.quantityCheckUpLimit)
      ) {
        this.$message.error('请填写占比上下限');
        return false;
      }
      if (
        this.pageForm.qualityCheckConfig.quantityCheckEnabled &&
        (this.pageForm.qualityCheckConfig.quantityCheckLowLimit < 1 ||
          this.pageForm.qualityCheckConfig.quantityCheckUpLimit < 1)
      ) {
        this.$message.error('请填写大于0的整数');
        return false;
      }
      // if (
      //   this.pageForm.qualityCheckConfig.appInputMonthMaxCheckEnabled &&
      //   (!this.pageForm.qualityCheckConfig.appInputMonthMax)
      // ) {
      //   this.$message.error('请填写问卷单日上限');
      //   return false;
      // }
      // if (
      //   this.pageForm.qualityCheckConfig.appInputMonthMaxCheckEnabled &&
      //   (this.pageForm.qualityCheckConfig.appInputMonthMax < 1 )
      // ) {
      //   this.$message.error('请填写大于0的整数');
      //   return false;
      // }
      if (this.pageForm.isSharing == '1') {
        // for (var i = 0; i < this.pageForm.subjectList.length; i++) {
        //   if (
        //     this.pageForm.subjectList[i].subjectType == '调研对象' ||
        //     this.pageForm.subjectList[i].subjectType == '客户名称' ||
        //     this.pageForm.subjectList[i].subjectType == '选择医疗机构' ||
        //     this.pageForm.subjectList[i].subjectType == '选择等级医院' ||
        //     this.pageForm.subjectList[i].subjectType == '选择基层医疗' ||
        //     this.pageForm.subjectList[i].subjectType == '选择药店' ||
        //     this.pageForm.subjectList[i].subjectType == '选择商业公司' ||
        //     this.pageForm.subjectList[i].subjectType == '定位签到' ||
        //     this.pageForm.subjectList[i].subjectItemType == '2'||
        //     this.pageForm.subjectList[i].subjectItemType == '3'
        //   ) {
        //     this.$message.error('支持分享的问卷不可配置【调研对象、客户类题型、科室、产品、签到】题型，请删除该题目或者改为不分享问卷');
        //     return false;
        //   }
        //   if(this.pageForm.subjectList[i].selectItems&&
        //   this.pageForm.subjectList[i].selectItems.length>0
        // ){

        //   }
        // }
        
        try{
          // 如果添加了签到题型，选择客户或者选择其他机构的题型只能选择一项
          if(this.pageForm.subjectList&&this.pageForm.subjectList.length>0){
            this.pageForm.subjectList.forEach(item=>{
              if(item.subjectType== '调研对象'||
                item.subjectType==  '客户名称'||
                item.subjectType==  '选择医疗机构'||
                item.subjectType == '选择等级医院'||
                item.subjectType == '选择基层医疗'||
                item.subjectType == '选择药店'||
                item.subjectType == '选择商业公司'||
                item.subjectType == '定位签到'||
                item.subjectItemType == '2'||
                item.subjectItemType == '3'
              ){
                // this.$message.error('支持分享的问卷不可配置【调研对象、客户类题型、科室、产品、签到】题型，请删除该题目或者改为不分享问卷');
                throw new Error('支持分享的问卷不可配置【调研对象、客户类题型、科室、产品、签到】题型，请删除该题目或者改为不分享问卷');
              }
              if(item.selectItems&&item.selectItems.length>0){
                ////题目有选项
                item.selectItems.forEach(items=>{
                  if(items.subjectItem &&
                  (
                  items.subjectItem.subjectType=='选择医疗机构'||
                  items.subjectItem.subjectType=='选择等级医院'||
                  items.subjectItem.subjectType=='选择基层医疗'||
                  items.subjectItem.subjectType=='选择药店'||
                  items.subjectItem.subjectType=='选择商业公司'||
                  items.subjectItem.subjectType == '定位签到'||
                  items.subjectItem.subjectItemType == '2'||
                  items.subjectItem.subjectItemType == '3'
                  )){
                    throw new Error('支持分享的问卷不可配置【调研对象、客户类题型、科室、产品、签到】题型，请删除该题目或者改为不分享问卷');
                  }
                })
              }
            })
          }
        } catch (e) {
          this.$message.error(e.message);
          return false;
        }
        
      }
      
      // if (this.organisationNameList == '') {
      //   this.$message.error('请选择应用部门');
      //   return;
      // }}
      
      return true;
    },
    //问卷 - 提交
    saveReq(type,flg) {
      // flg为1已经出现过校验提示
      let self = this;
      let functionCode = this.$route.query.functionCode;
      if(flg!==1){
        if (!this.checkForm()) {
          return;
        }
        if(this.pageForm.surveyExecuteRules&&this.pageForm.surveyExecuteRules.length>0&&!this.checkConfig()){
          return;
        }
      }
      
      
      if (this.pageForm.isOpenProtocol !== 'Y') {
        this.pageForm.protocolKeyWord = null;
      }
      
     
      this.pageForm.subjectList.forEach((k) => {
        if (k.subjectType !== '单行填空题') {
          k.isValidateUnique = 'N';
        }
      });
      // if (this.organisationNameList == '') {
      //   this.$message.error('请选择应用部门');
      //   return;
      // }
      let organisationGuid = [];
      let organisationName = [];
      this.departmentList.forEach((item) => {
        organisationGuid.push(item.guid);
        organisationName.push(item.organisationName);
      });
      this.pageForm.organisationGuid = organisationGuid;
      this.pageForm.organisationName = organisationName;
      this.pageForm.serviceTenantGuid = localStorage.guid;
      self.fullscreenLoading = true;
      let resultData = JSON.parse(JSON.stringify(this.pageForm));
      if (type) {
        resultData.isDraft = 'Y';
      } else {
        resultData.isDraft = 'N';
      }
      resultData.notSelfSubmit = resultData.notSelfSubmit?'Y':'N'
      // 进行编辑 N-草稿 A-发起审批
      let subjectChanged = false
      if (this.isEdit && !this.isResubmit) {
        // 题目内的任何改动（标题、选项、类型、是否必填等）都需要重新走审批流
        subjectChanged = !isEqual(resultData.subjectList, this.originalSubjectList)
        resultData.bizApproveState = subjectChanged ? 'A' : 'N'
      } else {
        resultData.bizApproveState = resultData.isDraft == 'N' ? 'A' : 'N'
      }
      let flowType = '00042'
      if (this.isResubmit) {
        // 重新提交
        flowType = '00042';
        resultData.restartApproveGuid = resultData.approveVO?.approveGuid;
        if (resultData?.approveVO?.flowType == '00042') {
          resultData.guid = null;
        }
        // 重新提交 原本是什么流程 重新提交就是什么流程提交
        if (resultData?.approveVO?.flowType) {
          flowType = resultData.approveVO.flowType
        }
      } else if (this.isEdit) {
        if (resultData.approveVO?.flowType) {
          // 有历史审批流记录，沿用原流程
          flowType = resultData.approveVO.flowType
          // 如果当前是新增流程,并且是已通过的情况,后端让传 00043
          if (flowType == '00042' && resultData.approveVO.approveState == 'Y') {
            flowType = '00043'
          }
        } else if (this.pageForm.isDraft == 'Y') {
          // 草稿编辑：首次提交走新增审批流 00042
          flowType = '00042'
        } else if (subjectChanged) {
          // 历史/已发布数据编辑且题目变更：走变更审批流 00043
          flowType = '00043'
        } else {
          // 历史/已发布数据编辑未改题：走变更审批流 00043
          flowType = '00043'
        }
      }
      if (!resultData.approveVO && !type && this.pageForm.isDraft == 'Y') {
        // 没有审批流 提交 并且当前是草稿 发起审批
        resultData.bizApproveState = 'A'
      }
      if (this.isCopy && !type) {
        // 复制提交 走新增审批流 发起审批
        flowType = '00042'
        resultData.bizApproveState = 'A'
      }
      resultData.flowType = flowType
      resultData.dataFrom=this.dataFrom
      resultData.surveyText = (resultData.surveyText == '<p><br></p>'||resultData.surveyText=='') ? '' : resultData.surveyText
      resultData.surveyRuleConfig.visitRight.visitRadioList=this.visitRadioList
      if (this.branchList.length > 0) {
        resultData.subjectList.forEach((item) => {
          item.isUseBeSubjectRule=this.isRely(item)?'Y':'N'
        });
        resultData.surveySubjectRules=this.branchList.map(item=>{
          return {
            // guid:'',
            surveyTenantGuid: this.surveyGuid,
            ...item
          }
        })
      }else{
        resultData.surveySubjectRules=null
      }
     
      // 历史数据 value 为空 添加默认值
      resultData.subjectList = resultData.subjectList?.map((item) => {
        return {
          ...item,
          selectItems: item.selectItems?.map((o, idx) => {
            let value = o.value;
            if (SelectQuestionType.includes(item.subjectType) && !o.value) {
              value = SelectItemsValue[idx];
            }
            // 追加的子类
            const subjectItem = o.subjectItem || null;
            if (subjectItem?.selectItems) {
              subjectItem.selectItems = subjectItem.selectItems?.map((j, i) => {
                let childValue = j.value;
                if (SelectQuestionType.includes(subjectItem.subjectType) && !j.value) {
                  value = SelectItemsValue[i];
                }
                return {
                  ...j,
                  value: childValue,
                };
              });
            }
            return {
              ...o,
              value,
              subjectItem,
            };
          }),
        };
      });
      if (type == 1||flg==1) {//保存
        self.api
          .postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/add-or-update`, resultData)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              // self.dialogVisible = false;
              if (!this.pageForm.guid) {
                self.$message.success('新增成功');
              } else {
                self.$message.success('编辑成功');
              }
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
              self.fullscreenLoading = false;
            }
          })
          .catch(() => {
            self.fullscreenLoading = false;
          });
      }else {
        this.$confirm('即将发布问卷，确定继续操作吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          distinguishCancelAndClose: true,
          showClose: true,
          type: 'warning',
        })
          .then(() => {
            self.api
              .postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/add-or-update`, resultData)
              .then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  self.fullscreenLoading = false;
                  // self.dialogVisible = false;
                  if (!this.pageForm.guid) {
                    self.$message.success('新增成功');
                  } else {
                    self.$message.success('编辑成功');
                  }
                  self.$router.go(-1);
                } else {
                  self.$message.error(res.data.msg);
                  self.fullscreenLoading = false;
                }
              })
              .catch(() => {
                self.fullscreenLoading = false;
              });
          })
          .catch(() => {
            self.fullscreenLoading = false;
          });
      }
    },
    //新增选项（非调研对象）
    addSelect() {
      this.configForm.selectItemList.push({ text: '', value: '', orderNum: '' });
    },
    //新增选项（调研对象）
    addFirstSelectDy() {
      this.additionalProp1.config.push({
        text: '',
        value: '',
        orderNum: '',
        additionalList: [],
      });
    },
    //新增文案选项
    addSecondSelectDy(index) {
      this.additionalProp1.config[index].additionalList.push({
        text: '',
        value: '',
        orderNum: '',
      });
    },
    // 更新标签
    updateLabels(value) {
      if (value?.length > 3) {
        this.$message.warning('最多只能选择3个标签');
        // 保存之前的标签
        const originalValue = [...(this.pageForm.surveyLabelList || [])];
        
        if (originalValue.length >= 3) {
          // 已经有3个，恢复原来的值
          this.$nextTick(() => {
            this.$set(this.pageForm, 'surveyLabelList', originalValue);
          });
        } else {
          // 还没有3个
          this.$nextTick(() => {
            this.$set(this.pageForm, 'surveyLabelList', value);
          });
        }
      } else {
        this.$set(this.pageForm, 'surveyLabelList', value || []);
      }
    },
    async getHeartDictList() {
      const params = {
        name: "项目标签",
      };
      const { data } = await this.api.get(
        `/${serverConfig.msSalesPerformService}/common/get-heart-dict`,
        params
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.surveyLabelOptions = data.data.map(item => {
        return {
          ...item,
          disabled: true,
        }
      })
    },
    getSendTenantList() {
      let self = this;
      let query = {
        enterpriseCates: [...this.$getValueListByKey('上游客户分类'), '9901'],
        pageIndex: 1,
        pageSize: -1,
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.sendTenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // getTenantList() {
    //   let self = this;
    //   let query = {
    //     pageIndex: 1,
    //     pageSize: -1,
    //     enterpriseCates: ['010201'],
    //   };
    //   self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //       self.tenantList = res.data.data.records;
    //     } else {
    //       self.$message.error(res.data.msg);
    //     }
    //   });
    // },
    handleSelectFactory(val) {
      if (val) {
        this.getOrganisation(val);
        this.sendTenantList.forEach((item) => {
          if (item.guid == val) {
            this.pageForm.tenantName = item.tenantName;
          }
        });
      }
    },
    isContainOrg(arr, guid) {
      if (!arr.length) return 0;
      let flag = arr.findIndex((one) => {
        return one == guid;
      });
      if (flag == -1) {
        return 0;
      } else {
        return 1;
      }
    },
    disabledTreeNode(data, node) {
      let list = this.departmentList;
      if (list.length) {
        let flag = 0;
        let parentGuids = data.parentGuids ? data.parentGuids : [];
        for (let i = 0; i < list.length; i++) {
          let checkedParentGuids = list[i].parentGuids ? list[i].parentGuids : [];
          if (this.isContainOrg(parentGuids, list[i].guid)) {
            flag = 1;
            break;
          } else if (this.isContainOrg(checkedParentGuids, data.guid)) {
            flag = 1;
            break;
          } else {
            flag = 0;
          }
        }
        return flag > 0;
      } else {
        return false;
      }
    },
    //选择部门
    handleChooseDepart() {
      this.departmentVisible = true;
      this.$nextTick(() => {
        this.$refs.tree.setCheckedNodes(this.departmentList, true);
      });
    },
    //获取组织
    getOrganisation(guid) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?bizState=Y&tenantGuid=` + guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
            self.tableData = [];
          }
        });
    },
    unique(arr) {
      //Set数据结构，它类似于数组，其成员的值都是唯一的
      return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
    },
    //部门弹框选择
    handleNodeClick1(data) {
      this.departmentList = this.$refs.tree.getCheckedNodes(false);
      this.$forceUpdate();
    },
    //确定选择部门
    departmentSure(flag) {
      this.departmentVisible = false;
      let organisationNameList = [];
      if (this.departmentList.length == 0) {
        this.organisationNameList = [];
        // this.$message.error('请选择部门');
        // return;
      }
      this.departmentList.forEach((item) => {
        organisationNameList.push(item.organisationName);
      });
      this.organisationNameList = organisationNameList.join('、');
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选部门！');
        return;
      }
      self.delList.forEach((q) => {
        this.$refs.tree.setChecked(q, false, false);
      });
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      // self.delList.forEach(function (m) {
      //   self.area.forEach(function (n, idn) {
      //     if (JSON.parse(n).guid == m.guid) {
      //       self.area.splice(idn, 1);
      //     }
      //   });
      // });
    },
    //删除单个部门
    delDepartmentSingle(index) {
      this.departmentData.splice(index, 1);
      this.departmentList = this.departmentData;
      this.area.splice(index, 1);

      // this.departmentList.splice(index,1)
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    // 客户权限，完整资料建档、简易建档切换
    isSimpleFastAddChange() {
      this.$forceUpdate()
    }
  },
};
</script> 
<style scoped lang="less">
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner{
  background: #4fa1a4 !important;
  border-color: #4fa1a4 !important;
}
/deep/ .el-checkbox__label{
    line-height: 1;
    width: 99%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
  color:#212121;
}
.import-btn-tips {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: baseline;
}
.file-list-box{
  text-align: left;
}
.picture-box{
  display: flex;
  flex-direction: column;
  margin-left: 128px;
  .flex{
    display: flex;
  }
}
.item-tips{
  color: #F9793F;
  font-size: 12px;
  display: inline-block;
  margin-left: 99px ;
}
.avatar-uploader  {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.content {
  position: relative;
  // background: #fff;
  font-size: 18px;
  // padding: 10px;
  /* margin: 16px 2% !important; */
  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    margin-bottom: 4px;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 18px;
      font-weight: 400;
    }
    .approve-btn{
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      line-height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      right: 16px;
      top: 6px;
    }
    .approve-tag{
      font-size: 12px;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      line-height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      right: 16px;
      top: 6px;
    }
  }
}
.title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // margin-bottom: 10px;
  // padding-right: 20px;
  // padding-top: 10px;
  padding: 10px 20px;
  border-bottom: 1px solid #EBEEF5;
  background-color: #fafafa;
}
.title-config .title-block {
  width: 6px;
  height: 14px;
  background: #4fa1a4;
  display: inline-block;
  margin-right: 10px;
}
.title-config .title-tip {
  color: #7e7e7e;
  font-size: 14px;
  font-weight: 300;
  margin-left: 10px;
}
.clear-btn {
  height: 32px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  padding: 10px 20px;
  box-sizing: border-box;
  color: #fff;
  background: #4fa1a4;
  cursor: pointer;
}
.add-btn img {
  margin-right: 10px;
}
.base {
  background: #fff;
  // padding: 10px 0;
  border:1px solid #d9d9d9
}
.content h1 {
  margin: 0;
  margin-bottom: 16px;
}
.base-content {
  display: flex;
  font-size: 15px;
  // padding: 10px 0;
}
.base-content .base-info {
  display: flex;
  /* align-items: center; */
  line-height: 33px;
  padding: 0 40px;
}
.base-content .base-info .base-title {
  /* width: 115px; */
  flex-shrink: 0;
  text-align: right;
  word-break: keep-all;
  padding-right:13px;
}
.base-content .base-info .width-block{
width: 105px;
}
.base-info .base-tips {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}
.button-area {
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  padding-right: 20px;
  margin-top: 0;
}
.submit-survey-btn {
  display: flex;
  justify-content: center;
  padding-bottom: 50px;
  background: #e9eef3;
}
/* 添加题目 */
.dialog-title {
  display: flex;
  text-align: left;
  padding-bottom: 10px;
  border-bottom: 1px solid #dcdee0;
}
.dialog-title span {
  position: relative;
  width: 120px;
  display: block;
  font-size: 20px;
  margin-right: 28px;
  cursor: pointer;
  text-align: center;
}
.dialog-title span::after {
  content: '';
  display: block;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -12px;
  width: 0;
  height: 5px;
  background: #649fa4;
  transition: 0.4s;
}
.dialog-title-active::after {
  width: 78px !important;
}
.subject-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.subject-title-name {
  font-size: 16px;
  font-weight: bold;
  text-align: left;
}
.subject-title-name span {
  width: 6px;
  height: 14px;
  display: inline-block;
  background: #4fa1a4;
  margin-right: 10px;
}
.subject-add-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px 0;
}
.subject-add-btn {
  font-size: 14px;
  color: #649fa4;
  cursor: pointer;
  padding: 5px 9px;
  background: #f2f8f8;
  border: 1px solid #bfd2d3;
}
.subject-add-btn span {
  width: 18px;
  height: 18px;
  line-height: 17px;
  display: inline-block;
  margin-right: 6px;
  border: 1px solid #649fa4;
}
.opreateIcon {
  display: inline-block;
  width: 80px;
  text-align: left;
}

.opreateIcon i {
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  padding: 2px 6px;
  margin-left: 4px;
  background: #f5f7fa;
}

.opreateIcon i:hover {
  color: #4fa1a4;
}
.subject-select {
  display: flex;
  width: 88px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  color: #454545;
}
.subject-select div {
  width: 50%;
  text-align: center;
  border: 1px solid #dddddd;
  cursor: pointer;
}
.subject-select div:first-child {
  border-right: 1px solid #ddd;
}
.subject-select .true-active {
  color: #649fa4;
  background: rgba(234, 246, 247, 0.39);
  border: 1px solid #b0d0d3 !important;
}
.subject-select .false-active {
  color: #ff4d4d;
  background: rgba(255, 232, 232, 0.39);
  border: 1px solid #ff9b9b;
}
/* 批量选题 */
.choose-subject-box {
  display: flex;
}
.choose-subject-left {
  width: 260px;
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 16px;
  box-sizing: border-box;
  /* border-right: 1px solid #dcdee0; */
}
.choose-left-list {
  color: #323233;
  line-height: 20px;
  padding: 10px 32px;
  text-align: left;
  cursor: pointer;
}
.choose-left-active {
  background: #f7f8fa;
}
.choose-subject-right {
  flex: 1;
}
/* 题目列表 */
.subject-box {
  padding: 30px 140px;
  box-sizing: border-box;
}
.subject-icon-btn{
    display: flex;
    position: fixed;
    float: right;
    right: 30px;
    bottom: 200px;
    flex-direction: column;
    padding: 5px;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    font-size: 26px;
    background-color: #fff;
}
.subject-icon-btn i {
    cursor: pointer;
}
.subject-box-list {
  text-align: left;
  padding: 20px 0 0 0;
  border-bottom: 1px solid #e3e3e3;
}
.subject-title-left span {
  color: red;
}
.subject-title-left .subject-label-tag {
  display: inline-block;
  max-width: 220px;
  height: 26px;
  line-height: 26px;
  margin-left: 12px;
  padding: 0 14px;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  vertical-align: middle;
  background: #5f9df7;
  border-radius: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.subject-title-right {
  flex-shrink: 0;
  font-size: 14px;
}
.subject-title-right span {
  color: #649fa4;
  cursor: pointer;
}
.subject-list-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.subject-title-del {
  color: #676767 !important;
}
.subject-title-line {
  color: #c8c9cc !important;
}
.subject-group {
  display: flex;
  flex-flow: column;
  padding-left: 20px;
}
.rule-tips{
  font-size: 14px;
  color: #FF991C;
  letter-spacing: 0;
  line-height: 21px;
  margin-top: 0;
}
.subject-radio {
  margin-bottom: 10px;
}
/* 按钮颜色 */
/*添加*/
.el-button--white {
  color: #323233;
  background-color: #fff;
  border-color: #e4e6e7;
}
.el-button--white:focus,
.el-button--white:hover {
  color: #323233;
  background-color: #fff;
  border-color: #e4e6e7;
}
/* 标签添加按钮 */
.label-add-btn {
  color: #649fa4;
  cursor: pointer;
}
/* 自动选题 */
.automatic-distribution {
  padding-top: 5px;
  padding-left: 90px;
  text-align: left;
}
.distribution-list {
  display: flex;
  align-items: center;
  margin: 20px 0;
}
.distribution-list span {
  margin: 0 10px;
}
.search-area-div{
  flex-shrink: 0;
  text-align: right;
  margin-right: 4px;
}
.ipt-sty{
  flex: 1;
}
.el-col-6{
  display: flex;
  justify-content: flex-end;
}
.el-icon-question{
  color: #b2b2b2;
}
.dy-table {
  width: 800px;
  margin-left: 10px;
}

.dy-table .dy-table-title {
  display: flex;
  height: 60px;
  line-height: 60px;
  background: #f2f2f2;
  border-bottom: 1px solid #ddd;
}

.dy-table .dy-table-title div {
  width: 200px;
}

.dy-table .dy-table-item {
  display: flex;
  height: 50px;
  align-items: center;
  border-bottom: 1px solid #ddd;
}

.dy-table-item-label {
  width: 200px;
  flex-shrink: 0;
  text-align: center;
}

.dy-table .dy-radio-box {
  width: 200px !important;
  text-align: center;
}

</style>
<style lang="less">
.el-image-viewer__wrapper{
  z-index: 2099 !important;
}
.select-drop .el-select-dropdown__list{
  width:300px;
}
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.field-radio {
  display: flex;
  align-items: center;
}
.field-radio .el-form-item__content {
  margin-left: 0 !important;
}
.other-config {
  display: flex;
  font-size: 14px;
  padding-left: 50px;
  padding-top: 30px;
}
.other-content {
  flex: 1;
}
.other-content-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 20px; */
}
.other-title {
  padding-right: 30px;
}
.automatic-wrap-box{
  max-height: 300px;
  overflow-y: auto;
}
.distribution-title{
  display: inline-block;
  flex-shrink: 0;
  width: 110px;
  text-align: right;
}
.childDialog .el-dialog__body{
  padding:0 20px
}

.connectDialog{
  .button-box{
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
  }
  .title{
    border-bottom: 1px solid #dcdee0;
    background-color: #fff;
  }
  .title-box{
    text-align: left;
    display: flex;
    line-height: 32px;
    justify-content: space-between;
    .title{
      font-size: 18px !important;
      color: #212121;
      letter-spacing: 0;
      line-height: 27px;
      font-weight: 600 !important;
      border: none !important;
      padding: 10px 0 0;
    }
  }
  .title-left{
    display: flex;
    align-items: baseline;
    // margin-top: 5px;
    line-height: 36px;
    // margin-right: 4px;
    span{
      margin: 0 4px;
    }
  }
  .title-left-box{
    display: flex;
    align-items: baseline;
    span{
      width: 60px;
      text-align: right;
      margin-right: 4px;
    }

  }
  .title-right {
    flex-shrink: 0;
    font-size: 14px;
    margin-left: 10px;
  }
  .title-right span {
    color: #649fa4;
    cursor: pointer;
    margin-right: 10px;
  }
  .select-area-div{
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    background: #fff;
    // padding:0 20px;
    border: 1px solid rgba(229,229,229,1);
    width: 98%;
    margin: 15px 0 !important;
    .title-top{
      font-size: 14px;
      color: #212121;
      letter-spacing: 0;
      line-height: 48px;
      font-weight: 600;
      width: 99%;
      text-align: left;
      height: 48px;
      background-color: #fafafa;
      border: 1px solid rgba(229,229,229,1);
      padding-left: 6px;
      i{
        width: 24px;
        text-align: center;
      }
    }
    .select-box{
      font-size: 14px;
      width: 99%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: baseline;
      height: 38px;
      margin: 10px 0 0 10px;
    }
  }
  .subject-group{
    align-items: flex-start;
    flex-direction: column;
    width:98%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .subject-radio{
    text-align: left;
    width:98%;
  }
  .is-checked{
    background: #EBF6F7
  }
  
}
/* 审核被驳回提示样式 */
.review-reject-box {
  background: #fff7f7;
  border: 1px solid #ffcccc;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 4px;
}

.review-reject-header {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-bottom: 8px;
}

.review-reject-content {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  font-size: 13px;
  color: #666;
}

.review-item {
  display: flex;
  align-items: center;
}
.flow {
  background: #fff;
  padding-left: 20px;
}

.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;
}
.tooltip-content{
  p{
    margin: 5px;
    color: #666666;
  }
}
.cascader-popper {
  .el-cascader-menu {
    .el-cascader-menu__wrap {
      .el-cascader-menu__list {
        .is-disabled {
          display: none !important;
        }
      }
    }
  }
}
</style>